    window.responsive_maxwidth_palm = parseInt('680px',10);
    window.responsive_minwidth_lap = parseInt('681px',10);
    window.responsive_maxwidth_lap = parseInt('768px',10);
    window.responsive_minwidth_desk = parseInt('769px',10);



    window.addEventListener('load', function() {
      try {
      	new FastClick.attach('.fastclick');
      } catch (errFastClickAttach) {}
    }, false);


/** estimate date script 
14 April 	Friday 	Good Friday
17 April 	Monday 	Easter Monday
1 May 	Monday 	Early May bank holiday
29 May 	Monday 	Spring bank holiday
28 August 	Monday 	Summer bank holiday
25 December 	Monday 	Christmas Day
26 December 	Tuesday 	Boxing Day
**/


        function workingDaysFromTomorrow(days){    
        	try {
              
var month = new Array();
month[0] = "Jan";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Apr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Aug";
month[8] = "Sep";
month[9] = "October";
month[10] = "Nov";
month[11] = "Dec";
              
var weekday = new Array();
weekday[0] =  "Sunday";
weekday[1] = "Monday";
weekday[2] = "Tuesday";
weekday[3] = "Wednesday";
weekday[4] = "Thursday";
weekday[5] = "Friday";
weekday[6] = "Saturday";
              
              
        		var noOfDaysToAdd = days;

                var holiday = [];
                holiday[0] = new Date(2017, 03, 14); //Good Friday - remember that month is 0 to 11
                holiday[1] = new Date(2017, 03, 17); //Easter Monday - remember that month is 0 to 11
                holiday[2] = new Date(2017, 04, 1); //Early May bank holiday - remember that month is 0 to 11
                holiday[3] = new Date(2017, 04, 29); //Spring bank holiday - remember that month is 0 to 11
                holiday[4] = new Date(2017, 07, 28); //Summer bank holiday - remember that month is 0 to 11
                holiday[5] = new Date(2017, 12, 25); //Christmas Day - remember that month is 0 to 11
                holiday[6] = new Date(2017, 12, 26); //Boxing Day - remember that month is 0 to 11
                var startDate = new Date();
                var endDate = new Date(), count = 0;
                while (count < noOfDaysToAdd) {
                    endDate.setDate(endDate.getDate()+1);
                    // Date.getDay() gives weekday starting from 0(Sunday) to
                    // 6(Saturday)
                    if (endDate.getDay() != 0 && endDate.getDay() != 6 && !isHoliday(endDate,   holiday)) {
                        count++;
                    }
                }
                function isHoliday(dt, arr){
                    var bln = false;
                    for ( var i = 0; i < arr.length; i++) {
                        if (compare(dt, arr[i])) { //If days are not holidays
                            bln = true;
                            break;
                        }
                    }
                    return bln;
                }
                function compare(dt1, dt2){
                    var equal = false;
                    if(dt1.getDate() == dt2.getDate() && dt1.getMonth() == dt2.getMonth() && dt1.getFullYear() == dt2.getFullYear()) {
                        equal = true;
                    }
                    return equal;
                }
              	var wd = endDate.getDay();
              	var fullday = weekday[wd];
              	var d = endDate.getDate();
				var m = endDate.getMonth();
              	var fullmonth = month[m];
				var y = endDate.getFullYear() - 2000;
              	var utc = fullday + ' ' + d + ' ' + fullmonth + ' ' + y ;
            	return(utc);

            }
      
            catch (datescriptERR) {
                console.log(datescriptERR.message);
            }       
                  
        }
		console.log('-------- fast track expected '+ workingDaysFromTomorrow(7));

/** estimate date script END **/

//credits http://css-tricks.com/snippets/jquery/move-cursor-to-end-of-textarea-or-input/
	jQuery.fn.putCursorAtEnd = function() {
		return this.each(function() {
	    	// If this function exists...
	    	if (this.setSelectionRange) {
	      		// ... then use it (Doesn't work in IE)
	      		// Double the length because Opera is inconsistent about whether a carriage return is one character or two. Sigh.
	      		var len = $(this).val().length * 2;
	      		this.focus();
	      		this.setSelectionRange(len, len);
	    	} else {
	    		// ... otherwise replace the contents with itself
	    		// (Doesn't work in Google Chrome)
	      		$(this).val($(this).val());
	    	}
		});
	};

$(document).ready(function() {
  
  try { 
		/* =======================================
		 * Initiate Stellar JS
		 * =======================================
		 */
		$.stellar({
			responsive: true,
			horizontalScrolling: false,
			hideDistantElements: false,
		});

		/* =======================================
		 * WOW JS
		 * =======================================
		 */
		var wow = new WOW({
			mobile : false,
			offset : 60,
		});
		wow.init();
    
      $(".hero-slider").each(function() {
          var t = $(this),
              auto          = t.data("autoplay") ? !0 : !1,
              loop          = t.data("loop") ? !0 : !1,
              rtl           = t.data("direction") ? !0 : !1,
              nav           = t.data("navigation") ? !0 : !1,
              pag           = t.data("pagination") ? !0 : !1;
              
          $(this).owlCarousel({
              items: 1,
              loop: loop,
              autoplay: auto,
              dots: pag,
              nav: nav,
              autoplayTimeout: 7000,
              navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
              autoplayHoverPause: false,
              touchDrag: true,
              mouseDrag: true,
              rtl: rtl
          });
          $(this).on("translate.owl.carousel", function () {

            onMoveCarousel($(this));
          
           
          });          
          $(this).on("translated.owl.carousel", function () {
			
            onCompleteCarousel($(this));

          });
        
          $(this).on("drag.owl.carousel", function () {
			onCompleteCarousel($(this));
          });          
          $(this).on("dragged.owl.carousel", function () {
            	onCompleteCarousel($(this));
          });  
        
      });
      function onMoveCarousel(thisObj){
			
		thisObj.find(".owl-item .hero-animate-wrap > *").each(function() {
            var the_class =  $(this).attr('data-class');
        	$(this).removeClass().addClass(the_class).addClass('invisible');
               //.removeClass("fadeInUp animated").css("opacity","0");
		}); 
        setTimeout(function(){ 
          	onCompleteCarousel(thisObj);
        }, 2000);
      }
      function onCompleteCarousel(thisObj){
        
       	thisObj.find(".owl-item .hero-animate-wrap > *").each(function() {
        	var the_class =  $(this).attr('data-class');
            var the_animation =  $(this).attr('data-animation');
            $(this).removeClass().addClass(the_class).addClass(the_animation+' animated');
            //.removeClass("fadeInUp animated").css("opacity","0");
      	}); 
        
      }
      $(".carousel-slider").each(function() {
          var t = $(this),
              auto          = t.data("autoplay") ? !0 : !1,
              loop          = t.data("loop") ? !0 : !1,
              rtl           = t.data("direction") ? !0 : !1,
              nav           = t.data("navigation") ? !0 : !1,
              pag           = t.data("pagination") ? !0 : !1,
        	  items           = t.data("items") ? !0 : !1;
              
          $(this).owlCarousel({
            autoHeight: true,
              items: items,
              loop: loop,
              autoplay: auto,
              dots: pag,
              nav: nav,
              autoplayTimeout: 7000,
              navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
              autoplayHoverPause: false,
              touchDrag: true,
              mouseDrag: true,
              rtl: rtl
          });
          $(this).on("translate.owl.carousel", function () {
            $(this).find(".owl-item .hero-animate-wrap > *").each(function() {
              	var the_class =  $(this).attr('data-class');
              	$(this).removeClass().addClass(the_class).css("opacity","0");
               //.removeClass("fadeInUp animated").css("opacity","0");
            }); 
           
            //$(this).find(".owl-item .slide-img").removeClass("fadeInRight animated").css("opacity","0");
          });          
          $(this).on("translated.owl.carousel", function () {
            $(this).find(".owl-item.active .hero-animate-wrap > *").each(function() {
              	var the_class =  $(this).attr('data-class');
              	var the_animation =  $(this).attr('data-animation');
              	$(this).addClass(the_animation+' animated').css("opacity","1");
               //.removeClass("fadeInUp animated").css("opacity","0");
            }); 
            
            //.addClass("fadeInUp animated").css("opacity","1");
            //$(this).find(".owl-item.active .slide-img").addClass("fadeInRight animated").css("opacity","1");
          });
      });
    
   
      $('.header-lines-boxes').on({
        'initialized.owl.carousel': function () { $('.header-box-lines-group').css('visibility', 'visible');}
      }).owlCarousel({
        loop: true,
        autoplay: true,
        items: 1,
        dots: false,
        smartSpeed: 1000,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false
      });
    
      /*$('.header-lines-boxes').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });*/
   
    
      $(".hero_typed").each(function() {
        var the_strings = $(this).siblings('.hero_type_content');
        var the_string_id = '#'+ the_strings.attr('id');
        var speed = parseInt(the_strings.attr("data-speed"));
        var delay = parseInt(the_strings.attr("data-delay"));
        var backspeed = parseInt(the_strings.attr("backspeed"));
        var loop = the_strings.attr("data-loop");
        var cursor = the_strings.attr("data-cursor");
        if (loop == 'true'){
        	loop = true;	  
        }
        else {
         	loop = false; 
        }
        if (cursor == 'true'){
        	cursor = true;	  
        }
        else {
         	cursor = false; 
        }
        var the_strings = '#'+$(this).siblings('.hero_type_content').attr('id');
      	var typed3 = new Typed('.hero_typed', {
          	stringsElement: the_string_id,
            typeSpeed: speed,
            backSpeed: backspeed,
            backDelay: delay,
            smartBackspace: true, // this is a default
            loop: loop,
          	cursorChar:'|',
            showCursor: cursor
      	});
      });
   
      $('body').on('click', '.content-block-more', function(event) {
        	if($(this).parents('.grid--item').find('.block-full-description').length){
              	var thecontent = $(this).parents('.grid--item').find('.block-full-description').html();
          		var thetitle = $(this).parents('.grid--item').find('.block-title').html();
                $.Zebra_Dialog(thecontent, {
                    type: false,
                    width: 800,
                    title:  thetitle
                });
            }

      });
    
    
    function let_it_snow(id,flakes){
	//canvas init
    
	var canvas = document.getElementById(id);
	var ctx = canvas.getContext("2d");
	
	//canvas dimensions
	var W = window.innerWidth;
	var H = window.innerHeight;
	canvas.width = W;
	canvas.height = H;
	
	//snowflake particles
	var mp = flakes; //max particles
	var particles = [];
	for(var i = 0; i < mp; i++)
	{
		particles.push({
			x: Math.random()*W, //x-coordinate
			y: Math.random()*H, //y-coordinate
			r: Math.random()*4+1, //radius
			d: Math.random()*mp //density
		})
	}
	
	//Lets draw the flakes
	function draw()
	{
      	if (canvas){
		ctx.clearRect(0, 0, W, H);
		
		ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
		ctx.beginPath();
		for(var i = 0; i < mp; i++)
		{
			var p = particles[i];
			ctx.moveTo(p.x, p.y);
			ctx.arc(p.x, p.y, p.r, 0, Math.PI*2, true);
		}
		ctx.fill();
		update();
        }
	}
	
	//Function to move the snowflakes
	//angle will be an ongoing incremental flag. Sin and Cos functions will be applied to it to create vertical and horizontal movements of the flakes
	var angle = 0;
	function update()
	{
		angle += 0.01;
		for(var i = 0; i < mp; i++)
		{
			var p = particles[i];
			//Updating X and Y coordinates
			//We will add 1 to the cos function to prevent negative values which will lead flakes to move upwards
			//Every particle has its own density which can be used to make the downward movement different for each flake
			//Lets make it more random by adding in the radius
			p.y += Math.cos(angle+p.d) + 1 + p.r/2;
			p.x += Math.sin(angle) * 2;
			
			//Sending flakes back from the top when it exits
			//Lets make it a bit more organic and let flakes enter from the left and right also.
			if(p.x > W+5 || p.x < -5 || p.y > H)
			{
				if(i%3 > 0) //66.67% of the flakes
				{
					particles[i] = {x: Math.random()*W, y: -10, r: p.r, d: p.d};
				}
				else
				{
					//If the flake is exitting from the right
					if(Math.sin(angle) > 0)
					{
						//Enter from the left
						particles[i] = {x: -5, y: Math.random()*H, r: p.r, d: p.d};
					}
					else
					{
						//Enter from the right
						particles[i] = {x: W+5, y: Math.random()*H, r: p.r, d: p.d};
					}
				}
			}
		}
	}
	
	//animation loop
	setInterval(draw, 33);
  
    }
    
    function runSnow(){
      	var flakes = 100;
        if ($(window).width() > 800) {
            $('.snow-canvas').each(function () {
                var snow_canvas_id = $(this).attr('id');
                let_it_snow(snow_canvas_id,flakes);
            }); 
      	}
    }
	runSnow();
    

    function truncate_content_block(){
      try {
        if ($('.truncate-me').length) {
            $('.truncate-me').each(function() {
              	var activatelink = 'magnify';
            	var chars = $(this).attr('data-max-characters');
              	chars = parseInt(chars, 10);
                $(this).shorten({
                	showChars: chars,
                    moreText: 'read more',
                  	theHref: '#mfp_popup',
                  	allcontentClass: 'allcontent rte',
                  	activateClass: activatelink,
                    lessText: 'read less'
                });
              
            });
        }
      } catch (err_truncate_content_block) {
      }
    }
  
  	truncate_content_block();
    
    
	$('body').on("click", ".view-content-popup .magnify", function(e) {
		
        e.preventDefault();
      	var parentObj = $(this).parents('.view-content-popup');
		var clonedHTML = parentObj.html();
      	var popupContent = parentObj.parents('.grid--item').find('.popup-content').html().replace('##popupcontent##',clonedHTML);
      	//alert(clonedHTML);
		$(this).magnificPopup({
			closeOnContentClick: true,
            items: {
              src: $('<div class="white-popup-block">' + popupContent + '</div>'),
              type: 'inline'
            },
          	src: clonedHTML,
			closeBtnInside: true
		}).magnificPopup('open');
	}); 

    
  } catch (errstellar) {}
  
  
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
  	var MqL = 955;
  
	//move nav element position according to window width
	moveNavigation();
  
  
    function matched_height(){
        // get test settings
        var byRow = $('body').find('.items-container .item');

        // apply matchHeight to each item container's items
        $('.matched-height-container').each(function() {
            $(this).children('.matched-height-item').matchHeight({
                byRow: byRow
            });
        });
    }
  
  
  
  
	handleMobileProductAdjustments();
  	try {
  		miniCartAdjustments();
  	} catch (errhmp) { }
	
    $(window).resize(function() {
      	moveNavigation();
        handleMobileProductAdjustments();
    	try {
    		miniCartAdjustments();
    	} catch (errhmp2) { }
        homepage_content_block(769,450); 
        productpage_content_block(769,200);
        collection_content_block(769,50);
      	matched_height();
    });
  
  
  
  
  
    window.responsive_maxwidth_palm = parseInt('680px',10);
    window.responsive_minwidth_lap = parseInt('681px',10);
    window.responsive_maxwidth_lap = parseInt('768px',10);
    window.responsive_minwidth_desk = parseInt('769px',10);     
  
  	/** ------------------------ HEADER -------------------**/
  
  
      if($('.template-product').length){
        	//tagsession('product_page',window.product_type);
     		try {
              
                var parentObj = $('#add-item-form');
                var id = parentObj.find('#selected_variant_id').attr('value');
                var unit_cost = parentObj.find('#_Unit-Cost').attr('money');
                if ($(".calculated-main-price").is('[data-mainprice]')) {
                  	
                    unit_cost = parentObj.find('.calculated-main-price').attr('data-mainprice');
                }
				console.log('ViewContent = '+id+' | unit_cost = '+unit_cost);
                fbq('track', 'ViewContent', {
                    content_type: 'product', //either 'product' or 'product_group'
                    content_ids: [id], //array of one or more product ids in the page
                    value: unit_cost,    //OPTIONAL, but highly recommended
                    currency: 'GBP' //REQUIRED if you a pass value
                });
        	}
			catch (body_template_productERR) { }
      }
  
  
  
          $('.show-lining-chart').magnificPopup({
            
			  closeOnContentClick: true,
			  closeBtnInside: true,
              type: 'inline',
              preloader: false,
              modal: true
          });
  
  
  
      
      if($('.fasttrack-date')){
        var ft_date = workingDaysFromTomorrow(7);
      	$('.fasttrack-date').html(ft_date);
      }
      if($('.standard-date')){
        var standard_date = workingDaysFromTomorrow(15);
      	$('.standard-date').html(standard_date);
      }
  
  
  
  	/** ----------------- NEW MOBILE NAV ------------------ **/
  
      $('body').on('click', '.trigger-side-menu', function(event) {

          var that = $(this);
          var wrap = that.parents('.side-push-wrap');
          that.toggleClass('open');
          $('.side-push-menu .sub-menu').removeClass('open');
          $('.side-push-menu').toggleClass('open');
          $('body').toggleClass('menu-open');

          //console.log('clicked!');
          event.preventDefault();


      });
  
      var sub_parent = $(".sub-parent > a");
      var sub_menu = $('.sub-menu');
  
      $('body').on('click', '.sub-parent > a', function(event) {

          var that = $(this); //cache when you can
          var parent_menu = that.parents('.side-push-menu');
          var menu_index = parent_menu.index();
          var current_item = that.next('.sub-menu');
          //console.log(parent_menu);
          parent_menu.addClass('sub-level1-open');
          current_item.addClass('open');


      });

      var sub_back = $('.sub-menu--back');
      $('body').on('click', '.sub-menu--back', function(event) {
        var that = $(this);
        var menuIndex = that.parent().index();
        var currentItem = that.parent('.sub-menu');
        var parent_menu = that.parents('.side-push-menu');
        currentItem.removeClass('open');
        parent_menu.removeClass('sub-level1-open');
      });

   	/** ----------------- NEW MOBILE NAV END ------------------ **/

	//open search form
	$('.cd-search-trigger').on('click', function(event){
		event.preventDefault();
      	
		toggleSearch();
	});

	$('.cd-overlay').on('click', function(){
		toggleSearch('close')
		$('.cd-overlay').removeClass('is-visible');
	});
  
  	if ($('.uk-check-section').length){
      try {
            $.get("https://ipinfo.io", function(response) {

              	var responsecountry = response.country;
              	//alert(responsecountry);
              	if (responsecountry == 'GI' || responsecountry == 'GB' || responsecountry == 'JE' || responsecountry == 'IM' || responsecountry == 'GG' || responsecountry == 'UK'){
                  	$('.uk-check-section').each(function () {
          				var ukcheckObj = $( this );
                      	ukcheckObj.remove();
          			});
                }
              	else{
                  
          			
                  	$('.uk-check-section').each(function () {
          				var ukcheckObj = $( this );
                      	ukcheckObj.show();
          			});
                      	
          			
              	}
            }, "jsonp");
        }
		catch (ukchecksectioerr) { }
    }
    $('body').on('change', '.uk-check-input', function(event) {
        var thisObj = $(this);
      
      	if (thisObj.prop('checked',true)){
          	$('.uk-check-section').each(function () {
          		var ukcheckObj = $( this );
                ukcheckObj.hide();
          	});
        	$('.calculated-section-inner .btn__shoppingbag').show();
        }
    });

	function toggleSearch(type) {

		if(type=="close") {
			//close serach 
			$('.cd-search').removeClass('is-visible');
			$('.cd-search-trigger').removeClass('search-is-visible');
			$('.cd-overlay').removeClass('search-is-visible');
          	$('body').removeClass('search-is-visible');
		} else {
			//toggle search visibility
			$('.cd-search').toggleClass('is-visible');
			$('.cd-search-trigger').toggleClass('search-is-visible');
			$('body').toggleClass('search-is-visible');
			$('.cd-search .search-input').focus();
			($('.cd-search').hasClass('is-visible')) ? $('.cd-overlay').addClass('is-visible') : $('.cd-overlay').removeClass('is-visible');
		}
	}

	function checkWindowWidth() {
		//check window width (scrollbar included)
        if( $(window).width() < (MqL)){
          
          	console.log('is mobile lets move'); 
          	
			return false;
		} else {
          	console.log('is desktop lets go back');
			return true;
		}
	}
  
	function moveNavigation(){
  		var desktop = checkWindowWidth();
        if ( desktop ) {
          	$('body').removeClass('is-mobile');
		} else {
          	$('body').removeClass('is-mobile').addClass('is-mobile'); 
		}
	}
  	/** ------------------------ HEADER END -------------------**/
  
    
    /* ------------------------ PRODUCT PAGE --------------------------------------------*/
  
	if ($('.product-colourways-wrap').length){
		$('.product-colourways-wrap').each(function () {
            try {
            var colourwaysObj = $(this);
            var targetURL = colourwaysObj.find('.product-colourways-link').attr('data-url');
            var max_colourways = 6;
            if( $(window).width() < (window.responsive_maxwidth_palm)){
                max_colourways = 5;
            }
            $.get(targetURL, function( data ) {
                var elecount = 0;
                if($(data).find('.grid-list-item').length > 1 ) {
                    var theResponse = $(data).find('.grid-items-inner').html();
                    var theeletotal = $(data).find('.grid-list-item').length;
                  	var block_title = colourwaysObj.attr('title');
                    if($('#'+block_title+theeletotal).length){
                      
                    }
                    else {
                      colourwaysObj.attr('id',block_title+theeletotal);
                      if(theeletotal > max_colourways){
                          elecount++;
                      }
                      $(data).find('.grid-list-item').each(function () {
                        elecount++;
                        var thisObj = $( this ).html();
                          if (elecount > max_colourways){
                              //additional
                            colourwaysObj.find('.colorways-main').prepend('<div class="cw-item-additional grid-list-item">' + thisObj + '</div>');
                          }
                          else{
                            colourwaysObj.find('.colorways-main').prepend('<div class="cw-item-main grid-list-item">' + thisObj + '</div>');
                          }
                      });	
                      //console.log('theResponse = '+theResponse);
                      if(theeletotal > max_colourways){
                          colourwaysObj.find('.colorways-toggle').show();
                      }
                      else{
                          colourwaysObj.find('.colorways-toggle').hide();
                      }
                      colourwaysObj.css('display','inline-block');
                  }
                }
            });
            }
            catch (colourwaysgaerr) { }
		});
          
	}
  

    $('body').on('click', '.colorways-toggle', function(event) {
      	var thisObj = $(this);
      	var thisParent = thisObj.parents('.product-colourways-wrap');
      	var closetext = thisObj.attr('data-closetext').trim().toLowerCase();
        var opentext = thisObj.attr('data-opentext').trim().toLowerCase();
        var thistext =  thisObj.text().trim().toLowerCase();
          if(thisParent.find('.cw-item-additional').is(":visible")){ 
          	thisParent.find('.cw-item-additional').each(function () {
            	$(this).hide();
            });
            thisObj.text(opentext);
          }
          else {
          	thisParent.find('.cw-item-additional').each(function () {
            	$(this).show();
            });
			thisObj.text(closetext);
          }
	});
  
  
  
    if ($('.other-products').length){
      	try {
          
		 	window.setTimeout(function(){        
                $('.other-products').each(function () {

                      var otherproductsObj = $( this );
                  
                  
                      var targetURL = otherproductsObj.find('.other-products-link').attr('href');
                      var targetURL = targetURL+'&view=product-page-other';
                      var destinationObj = otherproductsObj.find('.grid-items-inner');
                      var max_colourways = 8;

                      $.get(targetURL, function( data ) {
                          var elecount = 1;
                          if($(data).find('.grid-list-item').length > 1 ) {
                              var theResponse = $(data).find('.grid-items-inner').html();
                              var theeletotal = $(data).find('.grid-list-item').length;

                              $(data).find('.grid-list-item').each(function () {

                                elecount++;
                                var thisObj = $( this );
                                  if (elecount < max_colourways){

                                    destinationObj.append(thisObj);

                                  }
                              });	
                              otherproductsObj.css('display','inline-block');
                            try {
                              destinationObj.slick(getProductSliderSettings());
                            } catch (err_destinationObj_slick) {}

                          }
                      });

                }); 
        	},30);
        }
		catch (colourwaysgaerr) { }
    }
  
  
  /*function addSingleItem(free_id,free_width,free_type,free_repeat,free_cost,free_quanitiy){
		try {
          console.log("addSingleItem idL "+free_id+" width: "+free_width+" type: "+free_type+" repeat: "+free_repeat+" cost: "+free_cost+" quantity: "+free_quanitiy);
            $.ajax({
              type: "POST",
              url: '/cart/add.js',
              data: {
                    id: free_id,
                    properties: {
                      '_Fabric-Width': free_width,
                      '_Product-Type': free_type,
                      '_Repeat': free_repeat,
                      '_Unit-Cost': free_cost
                    },
                    quantity: free_quanitiy
                },
              async: false
            })
		}
		catch (gaerr) { }
	}*/
  
    /*$('body').on('click', '.add-free-gift', function(event) {
          if($('#add_free_gift').prop('checked')) {
              var formid = $('#add-item-form');
              var free_id = $('#add_free_gift').val();
              var free_width = parseInt($('[name="properties[_Fabric-Width]"]', formid).val(), 10);
              var free_type = $('#add_free_gift').attr('producttype');
              var free_repeat = parseInt($('[name="properties[_Repeat]"]', formid).val(), 10);
              var free_cost = parseInt($('[name="properties[_Unit-Cost]"]', formid).val(), 10);
              var free_quanitiy = $('#quantity').val();
            
              addSingleItem(free_id,free_width,free_type,free_repeat,free_cost,free_quanitiy);

          } else {
              // something else when not
          }
    });*/
  
  
	function gaEvent(category,action,label)
	{
		try {
			ga('send', 'event', {
				eventCategory: category,
				eventAction: action,
				eventLabel: label
			});
          	//tagsession(category,action);
          	console.log('---------gaEvent '+action+' ----------');
		}
		catch (gaerr) { }
	}
  
	function gaPageview(page)
	{
		try {	
			ga('send', 'pageview', page);
		}
		catch (gaerr) { }
	}
  
    
      $('body').on('click', '.show-lining-dialog', function(event) {

          var lining_content = $('.product-lining-wrap').html();
          $.Zebra_Dialog(lining_content, {
              type: false,
              width: 800,
              title:  'Linings'
          });

      });
      $('body').on('click', '.show-cushion-finish-dialog', function(event) {

          var cushion_finish_content = $('.product-cushion-finish-wrap').html();
          $.Zebra_Dialog(cushion_finish_content, {
              type: false,
              width: 800,
              title:  'Cushion Finish'
          });

      });
      $('body').on('click', '.product-apex-inside-wrap', function(event) {

          var apex_content1 = $('.product-apex-inside-wrap').html();
          $.Zebra_Dialog(apex_content1, {
              type: false,
              width: 800,
              title:  'Apex Curtains Measuring Guide (Inside Recess)'
          });

      });
      $('body').on('click', '.product-apex-outside-wrap', function(event) {

          var apex_content2 = $('.product-apex-outside-wrap').html();
          $.Zebra_Dialog(apex_content2, {
              type: false,
              width: 800,
              title:  'Apex Curtains Measuring Guide (Outside Recess)'
          });

      });
      $('body').on('click', '.show-blind-pleat-dialog', function(event) {

          var lining_content = $('.blind-pleat-dialog-wrap').html();
          $.Zebra_Dialog(lining_content, {
              type: false,
              width: 800,
              title:  'Roman Blind Pleat Information'
          });

      });
  
      $('body').on('click', '.show-chain-info-dialog', function(event) {

          var lining_content = $('.chain-info-dialog-wrap').html();
          $.Zebra_Dialog(lining_content, {
              type: false,
              width: 800,
              title:  'Roman Blind Chain Information'
          });

      });
  
      $('body').on('click', '.show-curtain-style-dialog', function(event) {

          var lining_content = $('.pleat-help-dialog').html();
          $.Zebra_Dialog(lining_content, {
              type: false,
              width: 800,
              title:  'Curtain Pleat Information'
          });

      });
  
        $('body').on('click', '.image-radio-button', function(event) {
	      
          var thisObj = $(this);
          var sectionObj = thisObj.parents('.image-radio-section-wrap');
          var itemObj = thisObj.parents('.image-radio-item');
          sectionObj.find('.image-radio-item').each(function () {
          	var thisObj1 = $( this );
            thisObj1.removeClass('selected');
          });
          sectionObj.find('input').each(function () {
          	var thisObj2 = $( this );
            thisObj2.prop('checked', false);
          });
          itemObj.find('input').prop('checked', true).change();
          itemObj.addClass('selected');

      });
  
     /** ------------------- facebook events ------------------- **/

      $('body').on('click', '.add-sample', function(event) {

             try {
              (async () => {
                const cartHelperStart = new Gadget();
                try {
        	        const cartLogResponse = await cartHelperStart.fetch("/logger", {
        	          method: "POST",
        	          headers: {
        	            "Content-Type": "application/json"
        	          },
        			  body: JSON.stringify({
        			    data: {
        			      url: window.location.href,
        			      error: "",
                          message: "Clicked add sample to cart",
                          p: {}
        			    }
        			  })
        	        });
                } catch (errl) {}
              })();
            } catch (errs) {}
        
        try {
        var parentObj = $(this).parents('form');
		var id = parentObj.find('#sampleid').attr('value');
        var unit_cost = parentObj.find('#_Unit-Cost').attr('value');
          
			fbq('track', 'AddSampleToCart', {
    			content_type: 'product', //either 'product' or 'product_group'
    			content_ids: [id], //array of one or more product ids in the page
    			value: 1.00,    //OPTIONAL, but highly recommended
    			currency: 'GBP' //REQUIRED if you a pass value
			});
        }
        catch (add_sampleERR) {
            console.log(add_sampleERR.message);
        }

      });

      $('body').on('click', '.main-product-add', function(event) {
        try {
            event.preventDefault();
            console.log("Adding product to cart......");

             try {
              (async () => {
                const cartHelperStart = new Gadget();
                try {
        	        const cartLogResponse = await cartHelperStart.fetch("/logger", {
        	          method: "POST",
        	          headers: {
        	            "Content-Type": "application/json"
        	          },
        			  body: JSON.stringify({
        			    data: {
        			      url: window.location.href,
        			      error: "",
                          message: "Clicked add product to cart",
                          p: {}
        			    }
        			  })
        	        });
                } catch (errl) {}
              })();
            } catch (errs) {}

            var customproduct = false;
            const $form = $('#add-item-form');
            const productType = $form.find('[name="properties[_Product-Type]"]').val();
            if (['Curtain Tracks', 'Curtain Poles', 'Curtain Holdbacks', 'Services'].includes(productType)) {
              console.log("Click main-product-add - Default add for "+productType);
              $form.submit();
            }
            else {
                customproduct = true;
                console.log("Click main-product-add - Custom add for "+productType);
            }

            try {
                var parentObj = $(this).parents('form');  
                var id = parentObj.find('#sampleid').attr('value');
            	var unit_cost = '';
                if ($(".calculated-main-price").is('[data-mainprice]')) {
                    unit_cost = parentObj.find('.calculated-main-price').attr('data-mainprice');
                }
    			fbq('track', 'AddMainToCart', {
        			content_type: 'product', //either 'product' or 'product_group'
        			content_ids: [id], //array of one or more product ids in the page
        			value: unit_cost,    //OPTIONAL, but highly recommended
        			currency: 'GBP' //REQUIRED if you a pass value
    			});
            } catch (fberr) {}


          /*###################################################################*/

          if (customproduct == true) {
            $(".main-product-add").addClass("loading");
            const productType = $('#add-item-form [name="properties[_Product-Type]"]').val();

            if (['Curtains', 'Apex Curtains'].includes(productType)) {
              if ($('#additional-item-quantity').val() > 0) {
                processExtrasForm();
              } 
              else {
                processForm();
              }
            }
            else {
              processForm();
            }
            
          }
          
          /*###################################################################*/
        }
        catch (add_addERR) {
            console.log("Add to Cart Error: "+add_addERR.message);
            $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 29'});

            (async () => {
              const cartHelper3 = new Gadget();
              try {
      	        const cartLogResponse = await cartHelper3.fetch("/logger", {
      	          method: "POST",
      	          headers: {
      	            "Content-Type": "application/json"
      	          },
      			  body: JSON.stringify({
      			    data: {
      			      url: window.location.href,
      			      error: "Error 29 in .main-product-add Click",
                        message: add_addERR.message,
                        p: {}
      			    }
      			  })
      	        });
              } catch (errl) {}
            })();
          
        }

      });

    //$('body').on('click', '.add-additional-item', function(event) {
    //});

    async function processForm() {

      try {
        
        const $form = $('#add-item-form');
        const formData = new FormData($form[0]);
        const formObject = {};

        console.log("Adding main product..");
      
        formData.forEach((value, key) => {
          let processedKey = key;
          if (key.startsWith('properties[')) {
            processedKey = key.replace('properties[', '').replace(']', '');
          }
          processedKey = processedKey.toLowerCase();
          formObject[processedKey] = value;
        });
        
        const productType = formObject['_product-type'];
        if (['Curtains', 'Valances', 'Apex Curtains', 'Roman Blinds'].includes(productType)) {
          formObject['_lining-unit-live'] = parseFloat($('#properties-lining :selected').attr('lining-unit'));
        }
        if (productType === 'Roller Blinds') {
          formObject['pricegroup'] = $('#properties-lining[name="properties[Type]"]').val();
          formObject['_pricegroupcode'] = $('#properties-lining[name="properties[Type]"]').find(':selected').attr('code');
        }

        const formDataJson = JSON.stringify(formObject, null, 2);
        //console.log('Processed add to cart form data:', formDataJson);
  
        const cartHelper = new Gadget();
        const cartResponse = await cartHelper.fetch("/addtocart", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ product: formObject })
        });
        
        if (!cartResponse.ok) {
          console.error('Failed to query add to cart:', cartResponse.statusText);
          $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 21'});
          try {
            const cartResponseJsonErr = await cartResponse.json();
  	        const cartLogResponse = await cartHelper.fetch("/logger", {
  	          method: "POST",
  	          headers: {
  	            "Content-Type": "application/json"
  	          },
  			  body: JSON.stringify({
  			    data: {
  			      url: window.location.href,
  			      error: "Error 21 Response Bad",
                  message: cartResponseJsonErr,
                  p: formObject
  			    }
  			  })
  	        });
  		} catch (errl) {}
          
        } else {
  
            try {
              const cartResponseJson = await cartResponse.json();
              console.log('Successfully queried add to cart:', cartResponseJson);

              if (cartResponseJson.message) {
                //let price = cartResponseJson.message.price;
                let productid = cartResponseJson.productid;
                let variantid = cartResponseJson.variantid;
                let price = cartResponseJson.price;
  
                if (price !== undefined) {
                  price = parseFloat(price).toFixed(2);
                  let jsprice = parseFloat($('#product_check').val()).toFixed(2);
                  //alert(`The price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}`);
                  
                  $('#selected_variant_id').val(variantid);

                  if (price == jsprice) {
                    console.log(`The price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}`);
                    const $form = $('#add-item-form');
                    $form.submit();
                    console.log(`Form submitted`);
                    $(".main-product-add").removeClass("loading");
                    
                  }
                  else {
                    console.log(`Price unmatched. The price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}`);
                    $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 22'});
                    try {
            	        const cartLogResponse = await cartHelper.fetch("/logger", {
            	          method: "POST",
            	          headers: {
            	            "Content-Type": "application/json"
            	          },
            			  body: JSON.stringify({
            			    data: {
            			      url: window.location.href,
            			      error: "Error 22 Price Unmatched",
                              message: "Price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}",
                              p: formObject
            			    }
            			  })
            	        });
            		} catch (errl) {}
                  }
                  
                } else {
                  console.error('Price is undefined in the response:', cartResponseJson);
                  $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 23'});
                    try {
            	        const cartLogResponse = await cartHelper.fetch("/logger", {
            	          method: "POST",
            	          headers: {
            	            "Content-Type": "application/json"
            	          },
            			  body: JSON.stringify({
            			    data: {
            			      url: window.location.href,
            			      error: "Error 23 Price Response Undefined",
                              message: cartResponseJson,
                              p: formObject
            			    }
            			  })
            	        });
            		} catch (errl) {}
                }
              } else {
                  console.error('Data is undefined in the response:', cartResponseJson);
                  $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 24'});
                    try {
            	        const cartLogResponse = await cartHelper.fetch("/logger", {
            	          method: "POST",
            	          headers: {
            	            "Content-Type": "application/json"
            	          },
            			  body: JSON.stringify({
            			    data: {
            			      url: window.location.href,
            			      error: "Error 24 Response .Message Undefined",
                              message: cartResponseJson,
                              p: formObject
            			    }
            			  })
            	        });
            		} catch (errl) {}
                }

            } catch (error) {
              console.error('Error parsing JSON response:', error);
              $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 25'});
              try {
      	        const cartLogResponse = await cartHelper.fetch("/logger", {
      	          method: "POST",
      	          headers: {
      	            "Content-Type": "application/json"
      	          },
      			  body: JSON.stringify({
      			    data: {
      			      url: window.location.href,
      			      error: "Error 25 Parsing JSON",
                      message: error.message,
                      p: formObject
      			    }
      			  })
      	        });
        	  } catch (errl) {}
              //alert('An error occurred while processing the cart response.');
            }
  
        }
               
      } catch (error) {
        console.error('Error processing add to cart form data or sending request:', error);
        $.Zebra_Dialog("Please contact the Showroom on <br/><b>0191 252 1111</b> if the problem persists.", {type: false, width: 250, title:  'Error 26'});
        const cartHelper2 = new Gadget();
        try {
	        const cartLogResponse = await cartHelper2.fetch("/logger", {
	          method: "POST",
	          headers: {
	            "Content-Type": "application/json"
	          },
			  body: JSON.stringify({
			    data: {
			      url: window.location.href,
			      error: "Error 26 in ProcessForm",
                  message: error.message,
                  p: {}
			    }
			  })
	        });
		} catch (errl) {}
      }
    }

    async function processExtrasForm() {

             try {
                const cartHelperStart = new Gadget();
        	    const cartLogResponse = await cartHelperStart.fetch("/logger", {
        	      method: "POST",
        	      headers: {
        	        "Content-Type": "application/json"
        	      },
        		body: JSON.stringify({
        			data: {
        			  url: window.location.href,
        			  error: "",
                      message: "Extra add to cart",
                      p: {}
        			}
        		})
        	    });
            } catch (errs) {}
      
      try {
        console.log(`Tiebacks to add`);
        const $form = $('#add-item-form');
        var formid = '#add-item-form';
        var item_id = $('#additional-item-cost').attr('variantid');
        var item_width = parseInt($('[name="properties[_Fabric-Width]"]', formid).val(), 10);
        var item_type = $('#additional-item-cost').attr('producttype');
        var item_repeat = parseInt($('[name="properties[_Repeat]"]', formid).val(), 10);
        var item_unit_cost = parseInt($('[name="properties[_Unit-Cost]"]', formid).val(), 10);
        var item_quantity = parseInt($('#additional-item-quantity').val(), 10);

        var product_img_url = $('[name="properties[_product_img_url]"]', formid).val();
        var product_url = $('[name="properties[_product_url]"]', formid).val();
        var product_sku = $('[name="properties[_product_sku]"]', formid).val();

        //console.log("addSingleItem id: "+item_id+" width: "+item_width+" type: "+item_type+" repeat: "+item_repeat+" uit cost: "+item_unit_cost+" quantity: "+item_quantity);
        // e.g. addSingleItem id: 32976354639 width: 135 type: Tie Backs repeat: 63 cost: 3900 quantity: 2
            
          const formObject = {};
          formObject["_product-type"] = item_type;
          formObject["_repeat"] = item_repeat;
          formObject["_fabric-width"] = item_width;
          formObject["_unit-cost"] = item_unit_cost;
          formObject["_product_check"] = (parseFloat($('#product_extra_check', formid).val())).toFixed(2);
          //formObject["_product_check"] = (parseFloat(item_unit_cost) * 0.01 * 0.5).toFixed(2); //HARD CODED
          console.log("Tiebacks", formObject);

          $('.pglobal').each(function() {
            let key = $(this).attr('name');
            let value = $(this).val();
            let processedKey = key;
            if (key.startsWith('properties[')) {
              processedKey = key.replace('properties[', '').replace(']', '');
            }
            processedKey = processedKey.toLowerCase();
            formObject[processedKey] = value;
          });
          
          const cartHelper = new Gadget();
          const cartResponse = await cartHelper.fetch("/addtocart", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ product: formObject })
          });
          if (!cartResponse.ok) {
            console.error('Failed to query add to cart:', cartResponse.statusText);
            processForm();
          } else {
          
              try {
                //#######################
                
                const cartResponseJson = await cartResponse.json();
                console.log('Successfully queried add to cart:', cartResponseJson);
        
                if (cartResponseJson.message) {
                  let productid = cartResponseJson.productid;
                  let variantid = cartResponseJson.variantid;
                  let price = cartResponseJson.price;
          
                  if (price !== undefined) {
                    price = parseFloat(price).toFixed(2)
                    console.log(`The price is: ${price}`);
                    
                    //let jsprice = parseFloat($('#product_check').val()).toFixed(2);
                    //alert(`The price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}`);

                    //if (price == jsprice) {
                      //console.log(`The price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}`);
                      //const $form = $('#add-item-form');

                      var data = {
                        id: variantid,
                        properties: {
                          '_Fabric-Width': item_width,
                          '_Product-Type': item_type,
                          '_Repeat': item_repeat,
                          '_Unit-Cost': item_unit_cost,
                          '_product_img_url': product_img_url,
                          '_product_url': product_url,
                          '_product_sku': product_sku
                        },
                        quantity: item_quantity
                      };

                      console.log('Tieback data to be sent:', data);

                      $.ajax({
                        type: "POST",
                        url: '/cart/add.js',
                        data: data,
                        dataType: 'json',
                        success: function() {
                          console.log('Tiebacks added');
                          processForm();
                        },
                        error: function(xhr, status, error) {
                          console.log('Error adding tiebacks:', error);
                          processForm();
                        }
                      });

                    //}
                    //else {
                    //  console.log(`Price unmatched. The price is: ${price} - VariantId: ${variantid}, JS price ${jsprice}`);
                    //  processForm();
                    //}
                    
                  } else {
                    console.error('Price is undefined in the response:', cartResponseJson);
                    processForm();
                  }
                } else {
                    console.error('Data is undefined in the response:', cartResponseJson);
                    processForm();
                }

                //#######################
        
              } catch (error) {
                console.error('Error parsing JSON response:', error);
                //alert('An error occurred while processing the cart response.');
                processForm();
              }

          }
                
      } catch (error) {
        console.error('Error processing add to cart form data or sending request:', error);
        processForm();
      }
    }

  	  var firstClick = 0;
      $('body').on('click', '.container', function(event) {
        try {
          	if(firstClick < 1){
              fbq('track', 'UserInteraction');
              firstClick++;
          	}
          	
        }
        catch (add_bodyclickERR) {
            console.log(add_bodyclickERR.message);
        }

      });
  
     /** ------------------- facebook events END --------------- **/ 
  
    $('body').on('click', '.fasttrack-pricing-link', function(event) {
      
        var lining_content = $('.fasttrack-popup-content').html();
		$.Zebra_Dialog(lining_content, {
    		type: false,
    		width: 600,
    		title:  'FastTrack'
		});
    
      
    });
  
    $('body').on('click', '.product-info-section-button', function(event) {
      	var thisObj = $(this);
        var parentObj = thisObj.parents('.product-info-section-wrap');
		var expandObj = parentObj.find('.product-info-section-expand');
      	if(expandObj.is(":visible")){ 
    		expandObj.slideUp();
        }
        else{
			expandObj.slideDown();
        }
      
    });
  
    $('body').on('click', '.contact-methods-chat-popup', function(event) {
      
      
        // values - true / false 

             /*purechatApi.set('chatbox.expanded', true);*/ // Expanded the chat box (false collapses it)
            zE('messenger', 'open');
      
      
    });
  
  
    $('body').on('click', '.contact-methods-phone,.contact-methods-email', function(event) {
      	var thisObj = $(this);
      	var parentObj = thisObj.parents('.contact-methods-wraps');
      	var revealObj = parentObj.find('.phone-reveal');
      	if ($(this).attr('method') == 'email') {
            revealObj = parentObj.find('.email-reveal');
        }
      	if(thisObj.attr('state') == 'closed'){
          	revealObj.show();
          	$(this).attr('state','opened');
      	}
        else if (thisObj.attr('state') == 'opened'){
          	revealObj.hide();
          	$(this).attr('state','closed');
        }
    });
  
    function scrollToAnchor(targetObj){
        var tag = targetObj;
        $('html,body').animate({scrollTop: tag.offset().top},'slow');
    }
  
  
    $('body').on('click', '.go-to-order', function(event) {
        scrollToAnchor($('#order-section-1'));
    });
    $('body').on('click', '.go-to-contact', function(event) {
        scrollToAnchor($('#contact_form'));
    });
    $('body').on('click', '.back-to-top', function(event) {
        scrollToAnchor($('body'));
    });
  
  
    $('body').on('click', '.mobile-sample .order-sample', function(event) {
      	var thisObj = $(this);
      	var closetext = $(this).attr('closetext').trim().toLowerCase();
        var opentext = $(this).attr('opentext').trim().toLowerCase();
        var thistext =  $(this).text().trim().toLowerCase();
      	console.log('thistext = '+ thistext + ' | opentext = '+ opentext + ' | closetext = '+ closetext);
        $('.product-sample').slideToggle('500',function(event) {
          if($('.product-sample').is(":visible")){ 
            thisObj.text(opentext);
          }
          else {
			thisObj.text(closetext);
          }
    	});
    });
    
    
    
	function handleMobileProductAdjustments() {
		//console.log('window.responsive_maxwidth_palm '+window.responsive_maxwidth_palm);
      /**
		$('.move-me-on-mobile').each(function() {
			var thisObj = $(this);
			var destinationObj = $(thisObj.attr('destination'));
			var originObj = $(thisObj.attr('origin'));
			if( $(window).width() < (window.responsive_maxwidth_palm)){
				//we are on a mobile width screen
				if (thisObj.is('[moved]')) {
				} else {
					//console.log('doesnt have moved attr');
					thisObj.detach().appendTo(destinationObj);
					thisObj.attr('moved','1');
					$('.slideshow-block').addClass('card-style');
				}
			}
			else {
				if (thisObj.is('[moved]')) {
					//console.log('does have moved attr');
					thisObj.detach().appendTo(originObj);
					thisObj.removeAttr('moved');
					$('.slideshow-block').removeClass('card-style');
				} else {
                  
                 
                  
				}
			}
		});
        **/
	}
  
    $('body').on('click', '.show-link', function(event) {
      	var thisObj = $(this);
      
      	var closetext = $('#faq_linktext').attr('closetext').trim().toLowerCase();
        var opentext = $('#faq_linktext').attr('opentext').trim().toLowerCase(); 
      
        var parentObj = thisObj.parents('.faq-row');
      	var targetObj = parentObj.find('.faq-answer');
      
        targetObj.slideToggle('300',function(event) {
          if($('.product-sample').is(":visible")){ 
            thisObj.text(opentext);
          }
          else {
			thisObj.text(closetext);
          }
    	});
    });
  
    function homepage_content_block(maxwidth,chars){
      try {
      var currentwidth = parseInt($( window ).width(),10);
      if(currentwidth < maxwidth){
        $('.home-page-info-inner').shorten({
            showChars: chars,
            moreText: 'read more',
            lessText: 'read less'
        });
      }
      } catch (err_homepage_content_block) {}
    }
  
    function productpage_content_block(maxwidth,chars){
      try {
      var currentwidth = parseInt($( window ).width(),10);
      if(currentwidth < maxwidth){
        $('.product-description-content').shorten({
            showChars: chars,
            moreText: 'read more',
            lessText: 'read less'
        });
        if($('.product-info-section-expand').length){
            $('.product-info-section-expand').each(function() {
            	$(this).slideUp();
            });
        }
      }
      } catch (err_productpage_content_block) {}
    }
  
    function collection_content_block(maxwidth,chars){
      try {
      var currentwidth = parseInt($( window ).width(),10);
      if(currentwidth < maxwidth){
        $('.collection-description-wrap.more').shorten({
            showChars: chars,
            moreText: 'read more',
            lessText: 'read less'
        });
      }
      } catch (err_collection_content_block) {}
    }
  
    function collection_longform_content_block(maxwidth,chars){
      try {
      var currentwidth = parseInt($( window ).width(),10);
      if(currentwidth < maxwidth){
        $('.longform-guide .grid-list-content-inner').shorten({
            showChars: chars,
            moreText: 'read more',
            lessText: 'read less'
        });
      }
      } catch (err_collection_longform_content_block) {}
    }
  
  function megaMenuColumnCount(){
	$('.mega-column').each(function() {
      	var parents = $(this).parents('.cd-secondary-nav');
      	var coloumnCount = parents.find('.mega-column').length;
      	parents.addClass('column-count-'+coloumnCount);
  	});
  }
  
  megaMenuColumnCount();
  
  if (parseInt($( window ).width(),10) > 600){
	homepage_content_block(3000,750);
    collection_content_block(3000,200);
    
    collection_longform_content_block(3000,200);
  }
  else{
     homepage_content_block(600,450); 
     productpage_content_block(600,200);
     collection_content_block(600,50);
    
     collection_longform_content_block(600,200);
  }

function getTagsForUrl(){
	var count = 0;
    var url_string = 'tag:';
  	var space_string = " ";
	var or_string = "%20OR%20";
  	var selectedValue = '';
  	var targetObj = $('.tag-checkbox:checked');
   	var targetObjRef = $('.tag-checkbox');
  	if (targetObj.length){
		targetObj.each(function() {
			selectedValue = $(this).val();
			count+=1;
			if(count > 1){
				url_string += or_string+selectedValue;
			}
			else{
				url_string += selectedValue;
			}

		});
      	console.log('tags -----------');
    }
    else{
		url_string += "*";
    }
  	console.log('tags end ------------');
  	higlight_selected_filter_btn();
  	return url_string;
}
function higlight_selected_filter_btn(){
  	var selectedText = 'Any';
  	$('.select-filter').each(function() {
      	var thisObj = $(this);
      	selectedText = thisObj.find('.selected-label').attr('default');
    	if(thisObj.find("input:checked").length){
          	console.log('has '+thisObj.children("input:checked").length +' checked values');
          	var selectedcount = thisObj.find("input:checked").length;
            thisObj.find('.selected-count').text(selectedcount).show();
            selectedText = $.map(thisObj.find("input:checked"), function(elem, index) {
                return $(elem).attr('text');
            }).join(',');
            
        	thisObj.find('.generic-dropdown-btn').removeClass('selected').addClass('selected');
    	}
      	else {
          	console.log('has no checked values');
          	thisObj.find('.selected-count').text('').hide();
        	thisObj.find('.generic-dropdown-btn').removeClass('selected');
        }
      	thisObj.find('.selected-label').text(selectedText);
  	});
}
function mobile_filter_count(){
  
  	try {
        var buttonObj = $('.search-filters-mobile-button');
        var textObj = buttonObj.find('.selected-text');
        var defaultText = textObj.attr('default');
        var selectedText = textObj.attr('selected');
        var countObj = buttonObj.find('.selected-count');
        var count = 0;
        if($('.select-filter input:checked').length){
            count = $('.select-filter input:checked').length;
        }
        if(count > 0){
           countObj.text(count).show();
           textObj.text(selectedText);
        }
        else {
           countObj.hide();
           textObj.text(defaultText);
        }
    }
  	catch (mobile_filter_countERR) {
      	console.log(mobile_filter_countERR.message);
	}
  	
}
function filter_count(){
  	try {
        $('.select-filter').each(function() {
            var thisObj = $(this);
            if(thisObj.find("input:checked").length){
                console.log('has '+thisObj.children("input:checked").length +' checked values');
                var selectedcount = thisObj.find("input:checked").length;
                thisObj.find('.selected-count').text(selectedcount).show();

            }
            else {
                console.log('has no checked values');
                thisObj.find('.selected-count').text('').hide();
            }
        });
  		mobile_filter_count();
    }
  	catch (filter_countErrr) {
      	console.log(filter_countErrr.message);
	}
  	
}
var buildSearchString_lastsearch = "";
  
function pushHistory(url) {
  try {
    
    //UPDATE URL
    try {
      var stateData = {
          "location": url
      }
      history.pushState(stateData, null, url); 
      cacheRedirectUrl();
    }
  	catch (errr) { console.log("Error pushHistory 1 "+errr.message); }
    
  }
  catch (err) { console.log("Error pushHistory 2 "+err.message); }
} 
  
  
function buildSearchString(refreshpage) {
  try {
  	console.log("Search buildSearchString *************");
  	var targetObj = false;
  	var searchtext = '*';
  	var producttype = "*"; //new change "Curtains";
  	var producttypetag = "*"; //new change "StandardCurtains";
    //if ($('.search-input-page').length) {
    //	searchtext = $('.search-input-page').val();
    //} else  
    if ($('.search-input-top').length && ($('.search-input-top').val() != "")) {
    	searchtext = $('.search-input-top').val();
      	console.log("Searchtext top buildSearchString: "+searchtext);
    }   
    else if ($('.search-input-mobile').length && ($('.search-input-mobile').val() != "")) {
    	searchtext = $('.search-input-mobile').val();
      	console.log("Searchtext mobile buildSearchString: "+searchtext);
    }
    else if ($('.search-input-page').length && ($('.search-input-page').val() != "")) {
    	searchtext = $('.search-input-page').val();
      	console.log("Searchtext page buildSearchString: "+searchtext);
    }
    console.log("Searchtext buildSearchString: "+searchtext);
    targetObj = $("#product-selector");
  	if (targetObj.length) {
      	producttypetag = targetObj.val();
         
      	try {
          	console.log("ptypesearchoption");
            $('.ptypesearchoption').removeAttr('selected');
            $('.ptypesearchoption').removeProp('selected');
            $('.ptypesearchoption[tag="'+producttypetag+'"]').attr('selected', 'selected');
            $('.ptypesearchoption[tag="'+producttypetag+'"]').prop('selected', 'selected');
            console.log("('.ptypesearchoption[tag='"+producttypetag+"']').attr('selected', 'selected');");
          
            targetObj = $("#product-selector option:selected");
            if (targetObj.length) {
                var producttypetext = targetObj.attr("text");
                if (producttypetext.length) {
                    $('.nav-search-label').text("Search "+producttypetext);
                }
    		}
        } 
      	catch (errptypesearchoption) {console.log("Error "+errptypesearchoption.message);}      
    }
    targetObj = $("#product-selector option:selected");
  	if (targetObj.length) {
      	producttype = targetObj.attr('parentproducttype');
    }
    
    searchtext = searchtext.replace(/[\s]+/g, '* ') + "*";
    searchtext = searchtext.replace(/[\*]+/g, '*');
    if (searchtext == "") {
    	searchtext = "*";
    }
   
    /*var searchtexted = searchtext.replace(/[\s]/g, '').toLowerCase().replace(/s/g, '');
    $(".alltypes_filtertags").each(function() {      
		var filter_tag = $(this).attr("tagtag");
        var filter_name = $(this).attr("tagname");
        var filter_name_ed = $(this).attr("tagnameed");
        var filter_parent_tag = $(this).attr("parentproducttype");
        var filter_parent_type = $(this).attr("parenttype");    
        if (searchtexted.indexOf(filter_name_ed) >= 0) {  
            if (producttypetag != filter_tag) {
                producttype = filter_parent_type;//filter_name;
                producttypetag = filter_tag;
                //refreshpage = 1;
            }
        } 
    });*/
    
    if (producttype == "") {
    	producttype = "*";
    }
    if (producttypetag == "") {
    	producttypetag = "*";
    }   
    
    console.log("buildSearchString product_type: "+producttype+" "+producttypetag);
    //alert("Search buildSearchString");
              
    var url_string = '/search?q=' + searchtext + '%20AND%20' + 'product_type:' + producttype;
  	url_string += '%20AND%20' + 'tag:' + producttypetag + '%20AND%20' + 'tag:instock'; //A
  
  	var ors = "";
  	var selectedValue;
  	var parentObj = false;
    var parentObjs = $('.filter-options-container');
    var targetObjs = false;
  	if (parentObjs.length) {
		parentObjs.each(function() {   
          	parentObj = $(this);
    		targetObjs = parentObj.find('.tag-checkbox:checked');
  
  			if (targetObjs.length) {
				ors = "";
              	targetObjs.each(function() {
          	
					selectedValue = $(this).val();
					if (ors.length > 0) {
						ors += '%20OR%20' + selectedValue;
					}
					else {
						ors += selectedValue;
					}

				});
              	url_string += '%20AND%20' + 'tag:' + ors;
    		}
    	});
    }
    
    var newurl = "https://www.curtainsmadeforfree.co.uk" + url_string + '&type=product&view=ajax';
    var newurlHistory = "https://www.curtainsmadeforfree.co.uk" + url_string + '&type=product';
   
  	console.log("buildSearchString: " + url_string);
    
    buildSearchString_lastsearch = newurl;
    
  	filterbar_search(newurl, refreshpage);    
    
    //UPDATE URL
    pushHistory(newurlHistory);    
        
  }
  catch (err) { console.log("Error buildSearchString "+err.message); }
}
  
function filterbar_search(theurl, refreshpage) {
  try {
    
    	if (typeof(large_loading) == "undefined") {
          var large_loading = '<div class="loader1"><div><div><div><div><div><div></div></div></div></div></div></div></div><div class="loader-text">Loading.....</div>';
        }
  
		loadingNextPage = true;
      	var parentObj = $('#main');
		parentObj.find('.list-loading').show();
  		var loadingHTML = '<div style="background:rgba(248, 248, 248, 0.81);width:100%;height:100%;position:absolute;z-index:10;left:0px;top:0px;">' + large_loading + '</div>';
  		parentObj.find(".grid-items-inner").append(loadingHTML);
    closeAllFilters();
  		$('body').removeClass('show-mobile-filters');
  		filter_count();
    	console.log("filterbar_search...");
		$.ajax({
			url: theurl,
			dataType:'html',
			//timeout: 20000,
			success: function(msg){
              try {
              	console.log("filterbar_search has results, preparing..");
				loadingNextPage = false;
				parentObj.find('#pagination').remove();
				parentObj.find('#inifiniteLoader').hide();
				parentObj.find('.list-loading').hide();
				if (msg.length > 10) {
                  
                  if (buildSearchString_lastsearch == theurl) {
						parentObj.find('#inifiniteLoader').hide();
						parentObj.find('.list-loading').hide();
                                    		
						var theResponse = $(msg).find('.grid-items-inner').html();
						parentObj.find(".grid-items-inner").html(theResponse);   
                  		console.log("Updated results");
                  
                  		if (refreshpage == 1) {
                        	if ($(msg).find('.faucet-section-wrap').length) {
								var theFilters =  $(msg).find('.faucet-section-wrap').html();
                          		parentObj.find(".faucet-section-wrap").html(theFilters);
                              	console.log("Updated 'filters'");
                        	}
                          	else {
                            	console.log("No need to update 'filters'");
                            }
                        }
                  
                        if ($(msg).find('.info-bar-count').length) {
							var theitemCount =  $(msg).find('.info-bar-count').html();
                          	parentObj.find(".info-bar-count").html(theitemCount);
                        }
                  		                      
                        $('.product-list-img').each(function() {
                            var datasrc = $(this).attr('data-src');
                            $(this).attr('src',datasrc);
                        });
                    
                    	if ($('.collection-brand-top-wrap') && ($('.collection-brand-top-wrap').length) && ($('.collection-brand-top-wrap').length > 0)) {
                          $('.collection-brand-top-wrap').css("display","none");
                          $('.info-bar-wrap').css("padding","3em 0 0 0");
                        }
                        
                        if (paginationactive == false) {
                            paginationactive = true;
                            autoPagingInit($(window),$(document),$('#main'));
                        }  
                  		
                        window.setTimeout(function(){
                          try {
							swapImgSrc('.unveil');
                          } catch (err_swapImgSrc_t2) {}
                        },10);
                    
                  }
				}
				else {
						parentObj.find('#inifiniteFIN').fadeIn();
						parentObj.find('#inifiniteLoader').hide('1000');
				}
              } catch (errfilterbar_search) { console.log("Error errfilterbar_search: "+errfilterbar_search.message); }
			},
			error:function (xhr, ajaxOptions, thrownError){
					//alert(xhr.status);
					//alert(thrownError);
					loadingNextPage = false;
					return false;
			}
		});
  }
  catch (err) { console.log("Error errfilterbar_search2: "+err.message); }
}
  
window.clickedfilter = 'no';
var cat_search = 'Collection';
if($('.template-collection').length){
	cat_search = 'Collection'; 
}
if($('.template-search').length){
	cat_search = 'Search'; 
}
$('body').on('change', '#product-selector', function(event) {
    console.log('change type selector----------------');
    buildSearchString(1);
	if (window.clickedfilter == 'no'){
		gaEvent(cat_search,'Filter Clicked','');
		window.clickedfilter = 'yes';
	}
});
$('body').on('change', '#cmff-filters input:radio', function(event) {
  	console.log('change radio------------');
  	buildSearchString(1);
  	//buildSearchString(0);
	if (window.clickedfilter == 'no'){
		gaEvent(cat_search,'Filter Clicked','');
		window.clickedfilter = 'yes';
	}
});
  
if($('#searchUsedPriorityMatch').length){  
  	$("#searchUsedPriorityMatch").remove();
  	buildSearchString(1);
} 
  
$('body').on('click', '.results_searchterm span', function(event) {
  	
  	var targetValue = $(this).parents('.results_searchterm').attr('filter');
    $('#select-filter-'+targetValue).prop('checked', false).change();
  
});
  
$('body').on('change', '#cmff-filters input:checkbox', function(event) {
    console.log('------ othercheckbox:checkbox --------');
  	buildSearchString(1);
  	//buildSearchString(0);
  	if (window.clickedfilter == 'no'){
		gaEvent(cat_search,'Filter Clicked','');
		window.clickedfilter = 'yes';
	}
});
  
  
function closeAllFilters(){
	$('.generic-dropdown-wrap').removeClass('dropdown-active');
}
  
  	$('body').on('click', '.btn-close', function(event) {
		var parentObj = $(this).parents('.generic-dropdown-wrap');
		if (parentObj.hasClass('dropdown-active')){
			parentObj.removeClass('dropdown-active');
		}
		else{
			$('.generic-dropdown-wrap').removeClass('dropdown-active');
			parentObj.removeClass('dropdown-active').addClass('dropdown-active');
			
		}
	});

/** ------------------ COLLECTION REQUEST END ---------------- **/  
  
/* ------------------------- AJAX PAGING ------------------------- */
	function autoPagingInit(parentObj){
		console.log('--------- autoPagingInit --------------');
		/**
		var count = 2;
		var bottomOffset = '300';
      
			var autPaging = new Waypoint({
				element: $('footer'),
				offset: bottomOffset,
				handler: function(direction) {
                  	console.log('--------- footer in view  direction '+direction+'--------------');
					console.log('stickyBrowseBar Direction: ' + direction);
                      if(parentObj.find('#pagination').length){
                        loadArticle($('#main_container'));
                          count++;
                        }
				}
			})
      
      	**/
 
	}
	$('body').on("click",'.pagination-link',function(event) {
      	event.preventDefault();
		loadArticle($(this));

	});
	var autoPagingFuncSet = false;
	var loadingNextPage = false;
  	var collectionLoading = false;
  	var paginationactive = false;
	if($('.pagination').length){
      	paginationactive = true;
		autoPagingInit($('#main_container'));
	}
	
	function loadArticle(thisObj) {
		
		if(loadingNextPage === false){
          
          	var parentObj = thisObj.parents('#main_container');

            loadingNextPage = true;
          
            parentObj.find('.list-loading').show();
          	parentObj.find('.pagination-inner').hide();
          	parentObj.find('.pagination-loader').show();
          
            var loadingHTML = '<div style="background:rgba(248, 248, 248, 0.81);width:100%;height:100%;position:absolute;z-index:10;left:0px;top:0px;">' + large_loading + '</div>';
            parentObj.find(".grid-items-inner").append(loadingHTML);
            closeAllFilters();
            $('body').removeClass('show-mobile-filters');
            filter_count();
            console.log("filterbar_search...");
          	scrollToAnchor($('.grid-items-inner'));
          	if(parentObj.find('.pagination').length){
              	console.log();
              	var rawURL = thisObj.attr('href');
              	var theurl = thisObj.attr('href')+'&view=ajax';
              	
                $.ajax({
                    url: theurl,
                    dataType:'html',
                    //timeout: 20000,
                    success: function(msg){
                      
                      
                        loadingNextPage = false;
                        parentObj.find('.pagination').remove();
                        parentObj.find('#inifiniteLoader').hide();
                        parentObj.find('.list-loading').hide();
                      	
                      
                      
                        console.log('Load next page 3');
                        if (msg.length > 10) {
                          
                          	pushHistory(rawURL);
                          
                            parentObj.find('.list-loading').hide();
                            parentObj.find('.pagination-inner').show();
                            parentObj.find('.pagination-loader').hide();
                          
                            console.log('Load next page');
                            var theResponse = $(msg).find('.grid-items-inner').html();
                            //console.log('theResponse = '+theResponse);
                            parentObj.find(".grid-items-inner").html(theResponse);
                          
                            window.setTimeout(function(){
                              try {
                                swapImgSrc('.unveil');
                               } catch (err_swapImgSrc_t3) {}
                            },30);
 
                        }
                        else {
                            parentObj.find('.list-loading').show();
                            parentObj.find('.pagination-inner').show();
                            parentObj.find('.pagination-loader').show();
                        }
                    },
                    error:function (xhr, ajaxOptions, thrownError){
                        //alert(xhr.status);
                        //alert(thrownError);
                        loadingNextPage = false;
                        return false;
                    }
                });
            }
		}
		else {
			console.log('article is still loading');
		}
	}
  
/* ------------------------- AJAX PAGING END ------------------------- */

  
$('body').on('click', '.search-filters-mobile-button', function(event) {
	$('body').removeClass('show-mobile-filters').addClass('show-mobile-filters');
});
$('body').on('click', '.close-mobile-filters', function(event) {
	$('body').removeClass('show-mobile-filters');
});  
  
function back_to_top_of_filterbar(){
  /**
  var filterbarwrap = $('.cmff-explore-bar-wrap');
  var baroffset = filterbarwrap.offset();
  var doc = document.documentElement;
  var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
  if (top > baroffset.top){
    
	$('body,html').animate({
		scrollTop: baroffset.top ,
		}, 10
	);
    
  }
  **/
}
$('body').on('change', '.variant-selector', function () {
	
  	var newurl = window.this_domain + $(this).val();
    if ($(this).val() != ''){
        $(this).parents('.grid-list-item').find('.grid-list-link').attr('href',newurl);
        location.href = newurl;
    }
    else {
		$(this).parents('.grid-list-item').find('.grid-list-link').addClass('call-dropdown');
    }
});
$('body').on('click', '.grid-list-item .call-dropdown', function(event) {
  	var paretnObj = $(this).parents('.grid-list-item');
  	if(paretnObj.find('.choose-type-popup').length){
  		event.preventDefault();
  		paretnObj.removeClass('call-dropdown-show').addClass('call-dropdown-show');
  		$('body').removeClass('select_type_up').addClass('select_type_up');
    }
});
$('body').on('click', '.close-mobile-type-button', function(event) {
  	$('.grid-list-item').removeClass('call-dropdown-show');
  	$('body').removeClass('select_type_up');
});
  
$('body').on('click', '.toggle__shoppingbag', function(event) {
  	$('.grid-list-item').removeClass('call-dropdown-show');
  	$('body').removeClass('select_type_up');
});  
  
var large_loading = '<div class="loader1"><div><div><div><div><div><div></div></div></div></div></div></div></div><div class="loader-text">Loading.....</div>';
  
  /**
function filterbar_search(theurl){
		loadingNextPage = true;
      	var parentObj = $('#main');
		parentObj.find('.list-loading').show();
  		parentObj.find(".grid-items-inner").html(large_loading);
  		mobile_filter_count();
		$.ajax({
			url: theurl,
			dataType:'html',
			//timeout: 20000,
			success: function(msg){
				loadingNextPage = false;
				parentObj.find('#pagination').remove();
				parentObj.find('#inifiniteLoader').hide();
				parentObj.find('.list-loading').hide();
				if (msg.length > 10) {
						parentObj.find('#inifiniteLoader').hide();
						parentObj.find('.list-loading').hide();
						var theResponse = $(msg).find('.grid-items-inner').html();
						//console.log('theResponse = '+theResponse);
						parentObj.find(".grid-items-inner").html(theResponse);
                  		
						// This will be the div where our content will be loaded
							//historyEdit('replace',rawurl,document.title);
							//$('.list-loading').hide();
					window.setTimeout(function(){
							imageToBGCover();
								//$('.list-loading').hide();
								//console.log('positionOnboardingSlides timeout');
								//$('#inifiniteLoader').hide('1000');
					},2000);
				}
				else {
						parentObj.find('#inifiniteFIN').fadeIn();
						parentObj.find('#inifiniteLoader').hide('1000');
				}
			},
			error:function (xhr, ajaxOptions, thrownError){
					//alert(xhr.status);
					//alert(thrownError);
					loadingNextPage = false;
					return false;
			}
		});
}
 **/
  
 	$('.search-form').on('submit', function(event) {
      	console.log("Search search-form submit *************");
       	event.preventDefault();
		var thisObj = $(this);
		 var text = thisObj.find(".search-input").val(); 
		 var section = thisObj.find('input[name="q"]').attr("searchsection");
		 var q = addWildcards(text, section) + ' AND tag:instock'; //TOP SEARCH
		 thisObj.find('input[name="q"]').val(q);
		 //alert("Search search-form submit");      
      	 this.submit();
	}); 
  
  	$('.search-button').on('keypress click', function(e){
      	
		var search = $(this).val();
		if (e.which === 13 || e.type === 'click') {
			 $(this).trigger('submit');
		}
	});
  
  
  /* ---------------- autocomplete ---------------- */
  
          function addWildcards(phrase, section){
             try {
               
               phrase = phrase.trim().replace('  ', ' ').replace('*', '').toLowerCase(); 
               
               var type = phraseProductType(phrase);  
               
               if ($(".alltypes_filtertags").length) {
                 	$(".alltypes_filtertags").each(function() {    
                      	var filter_name_lo = $(this).attr("tagname").toLowerCase();
                    	phrase = phrase.replace(filter_name_lo, ""); 
               		});
               }              
                            
               phrase = phrase+'*';
               phrase = phrase.trim().replace(' ', '* ').replace('**', '*');               

               if (type == "") {
               		type = topProductType(phrase, section);  
               }

               return phrase + type;
             } catch (addWildcards1) { console.log("Error: "+addWildcards1.message); }
          }
          
          function topProductType(phrase, section){
             try {
               var selectedtypeTag = $('.product-type-selector-top option:selected').val();
               var parentType = $('.product-type-selector-top option:selected').attr('parentproducttype');
               
               if ((selectedtypeTag == "*") && (section == "mobile")) {
                 	var selectedtypeTag = $('.product-type-selector-top option:selected').val();
               }
               
               if (selectedtypeTag == "*") {
                   console.log("topProductType *");
                   return "";
               }               

               var typeString = ' AND product_type:'+parentType+' AND tag:'+selectedtypeTag;
               console.log("topProductType: "+parentType+" "+selectedtypeTag);
               return typeString;
             } catch (topProductType) { console.log("Error: "+topProductType.message); }
          }
  
          function phraseProductType(phrase){
             try {

               var type = "";
               var typeString =  "";
               var parentType = ""; var selectedtypeTag = ""; var matched_name = "";
               var searchtexted = phrase.replace(/[\s]/g, '').toLowerCase().replace(/s/g, '');
               if ($(".alltypes_filtertags").length) {
                    $(".alltypes_filtertags").each(function() {      
                        var filter_tag = $(this).attr("tagtag");
                        var filter_name = $(this).attr("tagname");
                        var filter_name_ed = $(this).attr("tagnameed");
                      	var filter_parent_tag = $(this).attr("parentproducttype");
                      	var filter_parent_type = $(this).attr("parenttype");   
                        if ((searchtexted.indexOf(filter_name_ed) >= 0) && ((filter_name.length > matched_name.length) || (parentType == ""))) {  
                            parentType = filter_parent_type;//filter_name;
                            selectedtypeTag = filter_tag;
                          	matched_name = filter_name;
                        } 
                    });
               }
               else { 
                 console.log("phraseProductType: - from "+phrase);
                 return ""; 
               }
               
               if ((parentType != "") && (selectedtypeTag != "")) {
               		typeString = ' AND product_type:'+parentType+' AND tag:'+selectedtypeTag;
                 	console.log("phraseProductType: "+parentType+" "+selectedtypeTag);
               }
               else {
                 	console.log("phraseProductType: - nomatch");
                 	return "";    
               }
               
               return typeString;
               
             } catch (phraseProductType) { console.log("Error: "+phraseProductType.message); }
          }
          
          $(document).on('change', '.product-type-selector-top', function() {
              try {
                  var currentFilter = $('.product-type-selector-top option:selected').attr('text');
                  $('.nav-search-label').html(currentFilter);
                  var labelWidth =  $('.product-type-selector-top').width();
                  $('.nav-fill').css('width','calc(100% - '+ labelWidth +')');
                  $('#headerSearch').autocomplete().clear();
              } catch (setupautocomp1) { console.log ("setupautocomp1 "+setupautocomp1.message); }
          });

          try {
          // Initialize ajax autocomplete:
          $('#headerSearch').autocomplete({
              serviceUrl: '/search?view=json',
              paramName: 'q',
              onSearchStart: function (query) {
                try {
                  console.log("headerSearch onSearchStart");
                  var query = addWildcards($('#headerSearch').val(), false) + ' AND tag:instock'; //AUTOCOMPLETE
                  $('#headerSearch').autocomplete().setOptions({ajaxSettings: {"data": { "q": query } } });
                } catch (headerSearchautocomp2) { console.log("Error headerSearchautocomp2: "+headerSearchautocomp2.message); }
              },
              onSelect: function(suggestion) {
                try {
                  console.log("headerSearch onSelect");
                  //$('#selction-ajax').html('You selected: ' + suggestion.value + ', ' + suggestion.data);
                  if ($('.noautocompclick').length) {
                    //Admin page
                    if (typeof autocompleteclicker == 'function') { 
                    	autocompleteclicker(suggestion.data); 
                    }
                  }
                  else {
                    window.location.href = suggestion.data;
                  }
                  } catch (headerSearchautocomp2d) { console.log("Error headerSearchautocomp2d: "+headerSearchautocomp2d.message); }
              },
              onHint: function (hint) {
                try {
                  console.log("headerSearch onHint");
                  $('#headerSearch-ajax-x').val(hint);
                } catch (headerSearchautocomp2b) { console.log("Error headerSearchautocomp2b: "+headerSearchautocomp2b.message); }
              },
              onInvalidateSelection: function() {
                try {
                  console.log("headerSearch onInvalid");
                $('#selction-ajax').html('You selected: none');
                 } catch (headerSearchautocomp2c) { console.log("Error headerSearchautocomp2c: "+headerSearchautocomp2c.message); }
              }
          });
          } catch (headerSearchautocomp) { console.log("Error headerSearchautocomp: "+headerSearchautocomp.message); }
  
  /* ---------------- autocomplete END ---------------- */
  
  
  
	/* HOME BANNER */
  	try {
	$('.cmff-home-banner-items').slick({
      	lazyLoad: 'ondemand',
		dots: true,
		infinite: true,
		prevArrow:$('.slick-prev'),
		nextArrow:$('.slick-next'),
		pauseOnHover:true,
		speed: 1000,
		fade: true,
		autoplay: false,
		cssEase: 'linear' 
	});
    } catch (err_cmffhomebanneritems_slick) {}
	/**
	$(".cmff-home-banner-look")	.mouseover(function() {
		$('.cmff-home-banner-items').slick('slickPause');
	}).mouseout(function() {
		$('.cmff-home-banner-items').slick('slickPlay');
	});
	**/
	/* HOME BANNER END */

  
    // beige*polka
    // title%3Abeige*polka*%20OR%20polka*%20OR%20beige*    
    function processSearchTitles(search_string){
      	//alert('search_string = "'+search_string +'"');
        search_string = search_string.replace('+', ' ').replace('%20', ' ');
        if (search_string.indexOf(' ') != -1) {
            var words = search_string.split(" ");
            if ((search_string.length == 0) || (search_string == '*')) {
              return '*';
            }
            else {
              var search_and_string = '';
              var search_or_string = '';
              var i;
              for (i = 0; i < words.length; i++) {
                if(words[i].length>0){
                  if(i > 0){
                    //search_and_string += ' AND ';
                  }
                  search_and_string += words[i]+'*';            
                  search_or_string += ' OR '+words[i]+'*';
                }
              }
              search_string = search_and_string + search_or_string;
              //alert('search_string = '+ search_string);
            }
          	return search_string;
        }
      	else{
        	search_string = search_string.trim().replace(/\*$/, '') + '*';
        	return search_string;
      	}
    }
  
    //https://cmff.myshopify.com/search?q=product_type%3ACurtains+AND+title%3Abeige*polka*%20OR%20polka*%20OR%20beige*%20AND%20vendor%3A*+AND+tag%3A*    
	/* LIKE ITEM */
  
  
        if ($('#wishlist .callblock').length){
        	$('.callblock').each(function () {
              var thisObj = $(this);
              var targetURL = $(this).attr('callblock');
              $.get(targetURL, function( data ) {
                  if (data.indexOf('main_container') != -1) {

                  }
                  else{
                    thisObj.replaceWith( data );
                  }
              });
			});
        }
  
	
	$('body').on("click",'.heart-item,.icon-heart',function() {
		var wishlist = $('.header-wishlist').find('.notification-count');
		var count = parseInt(wishlist.attr('count'),10);
		$(this).css("background-position","");
		var D = $(this).attr("rel");

		if(D === 'like') {
          	likeProduct($(this)); 
			wishlist.removeClass('updated').addClass('updated');
			$(this).addClass("heartAnimation").attr("rel","unlike");
			count = count+1;
			wishlist.attr('count',count);
			wishlist.html(count);
			wishlist.removeClass('updated');
		}
		else {
          	console.log('unlike');
          	unlikeProduct($(this));
			$(this).removeClass("heartAnimation").attr("rel","like");
			$(this).css("background-position","left");
		}
	});
	/* LIKE ITEM END */
	$('body').on("click",'.submit-the-cart',function() {
		$('#the_cart').trigger('submit');
	});
	/* -------------------- like product deal ------------------------ */
	function likeProduct(thisObj){
		try {
			if (window.loggedin){
				var theUrl = thisObj.attr('like');
				//console.log('logged in about to post');
				thisObj.addClass('loading');
				$.get(theUrl, function( data ) {
					if(data.indexOf("<success>") > -1) {
						//console.log('success, update class');
						thisObj.removeClass('loading').addClass('liked');
						thisObj.attr("rel", "unlike");
					}
					else{
						console.log('Like error: '+data);
						thisObj.removeClass('loading');
					}
				});
			} else {
				//console.log('not logged in');
				thisObj.removeClass('loading');
			}
		}
		catch (likeProductERR) {
			console.log(likeProductERR.message);
		}
	}
	function unlikeProduct(thisObj){
		try {
			if (window.loggedin){
				var theUrl = thisObj.attr('unlike');
				//console.log('logged in about to unlike');
				thisObj.addClass('loading');
              	if($('body#wishlist').length){
              		
					thisObj.parents('.grid-list-item').hide('300');
                }
				$.get(theUrl, function( data ) {
					if(data.indexOf("<success>") > -1) {
						//console.log('success, update class');
						thisObj.removeClass('loading').removeClass('liked');
						thisObj.attr("rel", "like");
					}
					else{
						console.log('Unlike error: '+data);
						thisObj.removeClass('loading');
					}
				});
			} else {
				//console.log('not logged in');
				thisObj.removeClass('loading');
			}
		}
      
		catch (unlikeProductERR) {
			console.log(unlikeProductERR.message);
		}
	}
	/* -------------------- like product END ------------------------ */
  
	
	if($('.column-list-js ul.columns-wrap').length){
      	$('.column-list-js ul.columns-wrap').each(function() {
      	  var maxcolumns = $(this).attr('maxcolumns');
          $(this).columnlist({
              size : maxcolumns,
              'class' : 'column-list',
              incrementClass : 'column-list-'
          });
          
        });
	}
	
	/* MINI BASKET */
	function filterDropdownSetup(){
		if($('#cmff-filters').length){
			var numOfFilters = $('.select-filter').length;
			if($('.select-filter').length){
				var filtrCount = 0;
				$('.select-filter').length / 2;
				$('.select-filter').each(function() {
					filtrCount++;
					if( ($('.select-filter').length / 2) >  filtrCount){
						$(this).removeClass('filter-left').removeClass('filter-right').addClass('filter-left');
					}
					else{
						$(this).removeClass('filter-left').removeClass('filter-right').addClass('filter-right');
					}
				});
				if($('.filter-options-container').length){
					console.log('------------ top '+document.getElementById('cmff-filters').getBoundingClientRect().top+' -------------------');
					/*$('.layout-columns').slimScroll({
						color: 'rgba(0, 0, 0, 0.75)',
						size: '10px',
						height: 'auto',
						position: 'right',
						wheelStep: 1
					});*/
				}
			}
		}
	}
	filterDropdownSetup();
  
    $('body').on('click', '.info-bar-icon', function(event) {
      	$('.info-bar-icon').removeClass('active');
        var thisObj = $(this);
      	var type = thisObj.attr('type');
      	thisObj.addClass('active');
        if(type == 'list'){
			$('body').removeClass('list-mode').addClass('list-mode');
        }
      	else{
			$('body').removeClass('list-mode');
      	}
    });
  
  	try {
	$('.layout-columns').slimScroll({
		color: 'rgba(0, 0, 0, 0.75)',
		size: '10px',
		height: '',
		position: 'right',
		wheelStep: 2
	});
    } catch (err_layoutcolumnsslimScroll) {}

	
	
	if($('.generic-dropdown').length){
		$("html").click(function(event) {
			if ($(event.target).parents('.generic-dropdown-wrap').length) {
				//console.log('clicking outside the notifications');
			}
			else{
				$('.generic-dropdown-btn').parents('.generic-dropdown-wrap').removeClass('dropdown-active');
				
			}
		});
	}
	/* FILTERS */
  
    function swapImgSrc(selector){
      try {
		$(selector).each(function() {
          	var thisObj = $(this);
              var source = $(this).attr('data-src');
              if (thisObj.is('[swapped]')){
              }
              else{
                  if (source) {
                    thisObj.attr("src", source).attr("swapped", '1');

                  }
              }
		});
      } catch (err_swapImgSrc) {}
    }
	window.setTimeout(function(){
      try {
		swapImgSrc('.unveil');
      } catch (err_swapImgSrc_t) {}
	},30);
  
  	/** ------------------ countdown timer ------------------ **/
  try {
  var ctstr = '2024/07/14 23:59:59';
  $('.productpage_fasttrack_clock').countdown(ctstr).on('update.countdown', function(event) {
        var thisObj = $(this);
        var secondscount = '';
        if(thisObj.attr('useseconds')){
          secondscount = '<span class="seconds"><b>%-S</b> sec</span>';
        }
        var format = '<span class="hours"><b>%H</b> hrs</span><span class="minutes"><b>%M</b> mins</span>'+secondscount;
        if(event.offset.totalDays > 0) {
          format = '<span class="days"><b>%-d</b> day%!d</span>' + format;
        }
        if(event.offset.weeks > 0) {
          format = '<span class="weeks"><b>%-w</b> week%!w</span>' + format;
        }
        $(this).html(event.strftime(format));
    }).on('finish.countdown', function(event) {
      $(this).html('This offer has expired!')
        .parent().addClass('disabled');

    });
  } catch (err_productpagefasttrackclock_countdown) {}
  
  try {
  var ectstr = '2019/02/01 23:59:59';
  $('.productpage_eventbox_clock').countdown(ectstr).on('update.countdown', function(event) {
        var thisObj = $(this);
        var secondscount = '';
        if(thisObj.attr('useseconds')){
          secondscount = '<span class="seconds"><b>%-S</b> sec</span>';
        }
        var format = '<span class="hours"><b>%H</b> hrs</span><span class="minutes"><b>%M</b> mins</span>'+secondscount;
        if(event.offset.totalDays > 0) {
          format = '<span class="days"><b>%-d</b> day%!d</span>' + format;
        }
        if(event.offset.weeks > 0) {
          format = '<span class="weeks"><b>%-w</b> week%!w</span>' + format;
        }
        $(this).html(event.strftime(format));
    }).on('finish.countdown', function(event) {
      $(this).html('')
        .parent().addClass('disabled');

    });
  } catch (err_productpageeventclock_countdown) {}
  
  try {
  var ectstr = '2024/11/12 23:59:59';
  $('.productpage_deliverybox_clock').countdown(ectstr).on('update.countdown', function(event) {
        var thisObj = $(this);
        var secondscount = '';
        if(thisObj.attr('useseconds')){
          secondscount = '<span class="seconds"><b>%-S</b> sec</span>';
        }
        var format = '<span class="hours"><b>%H</b> hrs</span><span class="minutes"><b>%M</b> mins</span>'+secondscount;
        if(event.offset.totalDays > 0) {
          format = '<span class="days"><b>%-d</b> day%!d</span>' + format;
        }
        if(event.offset.weeks > 0) {
          format = '<span class="weeks"><b>%-w</b> week%!w</span>' + format;
        }
        $(this).html(event.strftime(format));
    }).on('finish.countdown', function(event) {
      $(this).html('')
        .parent().addClass('disabled');

    });
  } catch (err_productpagedeliveryboxclock_countdown) {}
  
  try {
  	var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
  	var today_date = yyyy+'/'+mm+'/'+dd;
  	if ($('.fasttrack-clock').length){      	
        $('.fasttrack-clock').countdown(today_date+' 23:59:59').on('update.countdown', function(event) {
          	var thisObj = $(this);
          	var secondscount = '';
          	if(thisObj.attr('useseconds')){
            	secondscount = '<span class="seconds"><b>%-S</b> sec</span>';
            }
            var format = '<span class="hours"><b>%-H</b> hrs</span><span class="minutes"><b>%-M</b> min</span>'+secondscount;
            if(event.offset.totalDays > 0) {
              format = '<span class="days"><b>%-d</b> day%!d</span>' + format;
            }
            if(event.offset.weeks > 0) {
              format = '<span class="weeks"><b>%-w</b> week%!w</span>' + format;
            }
            $(this).html(event.strftime(format));
        }).on('finish.countdown', function(event) {

            $(this).html('Midnight Tonight').parent().addClass('disabled');

        });
    }
  } catch (err_fasttrack_clock_countdown) {}
  
  try {  
  	if ($('.hero-clock').length){
      	console.log('hero countdown');
      	$('.hero-clock').each(function() {
          	var countdown_yyyy = $(this).attr('yyyy');
          	var countdown_mm = $(this).attr('mm');
          	var countdown_dd = $(this).attr('dd');
            var ctstr = countdown_yyyy + '/' + countdown_mm + '/' + countdown_dd + ' 23:59:59';
            $(this).countdown(ctstr).on('update.countdown', function(event) {
                var thisObj = $(this);
                var secondscount = '';
              
              
              	var html_weeks = '';
				var html_days = '';
				var html_hours = '';
				var html_mins = '';
				var html_secs = '';
              
              	if(event.offset.weeks > 0) {
              	html_weeks = '<div class="countdown-grid">' +
					'<span class="countdown-number">%-w</span>' +
					'<span class="countdown-label">week%!w</span>' +
				'</div>';
                }
              	if(event.offset.totalDays > 0) {
				html_days = '<div class="countdown-grid">' +
					'<span class="countdown-number">%-d</span>' +
					'<span class="countdown-label">day%!d</span>' +
				'</div>';
                }
				html_hours = '<div class="countdown-grid">' +
					'<span class="countdown-number">%H</span>' +
					'<span class="countdown-label">hour%!H</span>' +
				'</div>';
				html_mins = '<div class="countdown-grid">' +
                    '<span class="countdown-number">%M</span>' +
                    '<span class="countdown-label">minute%!M</span>' +
				'</div>';
				html_secs = '<div class="countdown-grid">' +
                    '<span class="countdown-number">%-S</span>' +
                    '<span class="countdown-label">second%!S</span>' +
				'</div>';

                var format = html_weeks + html_days + html_hours + html_mins + html_secs;
                $(this).html(event.strftime(format)).show();
            }).on('finish.countdown', function(event) {

                $(this).html('Midnight Tonight').parent().addClass('disabled');

            });
        });
    }
  } catch (err_hero_clock_countdown) {
  	//alert(err_hero_clock_countdown);
  }
  
  
  /** ------------------ countdown timer END ------------------ **/
  
  
	$('body').on('click', '.btn-clear', function(event) {
		var parentObj = $(this).parents('.select-filter');
		parentObj.find('input:checkbox').removeAttr('checked');
		parentObj.find('.selected-label').html('All');
		parentObj.find('.generic-dropdown-btn').removeClass('selected');
	});
	
	$('body').on(' click', '.btn-apply', function(event) {
		var parentObj = $(this).parents('.select-filter');
		var checkedItems = parentObj.find('input[type="checkbox"]:checked').length;
		parentObj.find('.selected-label').html(checkedItems+' Selected');
		parentObj.find('.generic-dropdown-btn').removeClass('selected').addClass('selected');
	});
	$('body').on('click', '.btn-close', function(event) {
		closeAllFilters();
	});
	
	$('body').on('click', '.btn-apply', function(event) {
		var parentObj = $(this).parents('.select-filter');
		var checkedItems = parentObj.find('input[type="checkbox"]:checked').length;
		parentObj.find('.selected-label').html(checkedItems+' Selected');
		parentObj.find('.generic-dropdown-btn').removeClass('selected').addClass('selected');
	});
	/* FILTERS END */
	$('body').on('click', '.generic-dropdown-btn', function(event) {
		filterDropdownSetup();
		var parentObj = $(this).parents('.generic-dropdown-wrap');
		if (parentObj.hasClass('dropdown-active')){
			parentObj.removeClass('dropdown-active');
		}
		else{
			$('.generic-dropdown-wrap').removeClass('dropdown-active');
			parentObj.removeClass('dropdown-active').addClass('dropdown-active');
			
		}
	});
	/* MINI BASKET END */
	/* FOOTER */
	if($('.split-rows').length){
		$('.split-rows').each(function() {
			var numitems = $(this).find('.footer-logo').length;
			var targetObj = $(this).find('.footer-logo:nth-child('+Math.round(numitems/2)+')');
			$('<div class="clearfix"></div>').insertAfter(targetObj);
		});
	}
  	$('body').on('click', '.footer-header', function(event) {
      	var linksObj = $(this).parents('.footer-column-inner').find('.footer-links');
      	linksObj.slideToggle().toggleClass( "open" );
  	});
	/* FOOTER END */
	/* GENERAL FUNCTIONS */
	function imageToBGCover(){
		/**
		if ($('img.product-list-img').length){
			$('img.product-list-img').each(function() {
				var theObj = $(this);
				if (theObj.is("[fixed-bg]")){
					
					
				}
				else {
					
					var imgSrc = theObj.attr('src');
					var parentObj = theObj.parents('.product-list-img-wrap');
					var parentHeight = parentObj.height();
					var parentWidth = parentObj.width();
					theObj.css({
						"background": "url("+imgSrc+") no-repeat center center",
						"-webkit-background-size": "cover",
						"-moz-background-size": "cover",
						"-o-background-size": "cover",
						"background-size": "cover",
						"padding": "128px 121px",
						"height":"100%"
					});
					theObj.attr('fixed-bg');
				}
			});
		
		}
		**/
	}

  
  	/* -------------------------------------------------------- */
	/* ---------------------- AJAX LOGIN ---------------------- */
	/* -------------------------------------------------------- */
	/*
	* Try to login, check the login credentials, and then redirect if required.   
	*/
	$('.cd-user-llllmodal').on("click",'.login-button',function(event) {
		event.preventDefault();
		console.log('login-button clicked');
      	var theForm = $(this).parents('form');
      	if(theForm.valid()){
          var thisObj = $(this);
          theForm = thisObj.parents('form');
          var email = theForm.find('input[name="customer[email]"]').val();
          var password = theForm.find('input[name="customer[password]"]').val();
          theForm.find('.error-message').removeClass('is-visible').html('');
          theForm.find('.success-message').removeClass('is-visible').html('');
          theForm.find('.info-message').removeClass('is-visible').html('');
          login(email, password).done(function (html) {  
              //console.log('login ajax done');
              if (html.indexOf('Invalid login credentials') !== -1) {
                  // invalid password - show a message to the user
                  
                  //theForm.find('.error-message').html(errorMsgToUser).addClass('is-visible');

              } else {
                  // All good! Let's redirect if required
                  //console.log('Logged In');
                  theForm.find('.success-message').html('Success, we will now refresh the page.' ).addClass('is-visible');
                  var checkoutUrl = getCheckoutUrl();
                  if (checkoutUrl.length > 0) {
                      window.location.href = checkoutUrl;
                  } else {	
                      window.location.reload(true);
                  }
              }
          });
        }
	});
  
    var activationrun = false;
    function sendActivationCheck(parentObj){
    	try {
          if ($('#cd-activate-account.is-selected').length) {
            return false;
          }
          var theForm = parentObj.find('form');
          if(amplify.store('email')){
            var email = amplify.store('email');
            if (activationrun == false) {
              activationrun = true;
              $.ajax({
                url: "https://www.curtainsmadeforfree.co.uk/a/admin/post/sendActivationEmail.php?email="+email,
                type: "GET",
                success: function(response) {

                    var theresponse = response.trim().toLowerCase();
                    console.log("xmlhttp B: '"+theresponse+"'");
                    //check if we have emailed the user a activation link

                    var msgtouser = "We've sent you an email with a link to update your password. Please check your email and spam folder. \
                    If you have any problems please contact us on <a href='"+window.livechatlink+"' target='_blank' >Chat</a> and we can assist you.";


                    if (theresponse == 'emailed') {

                        theForm.find('.error-message').html(msgtouser).addClass('is-visible');

                        //theForm.find('.error-message').html('').removeClass('is-visible');
                        //theForm.find('.info-message').addClass('is-visible').fadeIn();
                    }
                    else {
                      	theForm.find('.error-message .activate_check_pending').remove();
                    }

                },
                error: function(xmlhttprequest, textstatus, message) {

                    //console.log("xmlhttperror B: '"+xmlhttprequest+"' '"+message+"'");
                    //var errorMsgToUser = "Invalid credentials, please try again.";                
                    //theForm.find('.error-message').html(errorMsgToUser).addClass('is-visible');

                }
              });
            }
          }
        }
        catch (sendActivationCheckerr) {
 			console.log("Error: "+sendActivationCheckerr.message)
            //alert(loginsesserr.message);
        }
    }
  
  
  
  
    function removeHash () { 
        var scrollV, scrollH, loc = window.location;
        if ("pushState" in history)
            history.pushState("", document.title, loc.pathname + loc.search);
        else {
            // Prevent scrolling by storing the page's current scroll offset
            scrollV = document.body.scrollTop;
            scrollH = document.body.scrollLeft;

            loc.hash = "";

            // Restore the scroll offset, should be flicker free
            document.body.scrollTop = scrollV;
            document.body.scrollLeft = scrollH;
        }
    }
  
    function getHash () {
      return window.location.hash;
    };
  
    // Allow deep linking to recover password form
    if (getHash() == '#recover') {
      forgot_password_selected($('.cd-form-forgot-pw'));
      //removeHash();
    }
  	if ($('#cd-reset-password').find('.success-message').hasClass('is-visible')) {
    	forgot_password_selected($('.cd-form-forgot-pw'));
	}  
  
	if ($('#cd-login').find('.error-message').hasClass('is-visible')) {
      	sendActivationCheck($('#cd-login'));
    }
  	if ($('#cd-reset-password').find('.error-message').hasClass('is-visible')) {
      	sendActivationCheck($('#cd-reset-password'));
	}
  	if ($('#cd-reset-password-submit').find('.error-message').hasClass('is-visible')) {
      	sendActivationCheck($('#cd-reset-password-submit'));
	}
  
	$('body').on("click",'.login-button',function(event) {
		//event.preventDefault();
      	var theForm = $(this).parents('form');
      	if(theForm.valid()){
            var email = theForm.find('input[name="customer[email]"]').val();
			amplify.store('email',email);
        }
	});
	$('body').on("click",'.reset-password',function(event) {
		//event.preventDefault();
      	var theForm = $(this).parents('form');
      	if(theForm.valid()){
            var email = theForm.find('input[name="email"]').val();
			amplify.store('email',email);
        }
	});
  	function cacheRedirectUrl(){
        try {

            var thisUrl = window.location.href;  

            //Update last pre-page for session *unless url is login)
            if (thisUrl.indexOf('/account/') == -1) { 
                //alert('write checkoutUrl = '+thisUrl);
                //Set vars
                $('.redirecturl').attr('value',thisUrl);
                amplify.store('checkout_url',null);
                amplify.store('checkout_url',thisUrl);
            }
            else {      
                console.log("no-write checkout_url - unchanged");      
            }  

            var checkoutDomain = location.protocol + '//' + location.host;	
            var data_store_checkout_url = amplify.store('checkout_url');     
            var checkoutUrlParam = getCheckoutUrl();
            var checkoutUrl = thisUrl; //default  

            if ((checkoutUrlParam) && (checkoutUrlParam.length > 0) && (checkoutUrlParam.indexOf('/account/') == -1)) { 
                //Overwrite from Param
                checkoutUrl = checkoutUrlParam;
                //alert('read checkoutUrl 1 (param) = '+checkoutUrl);
            }
            else if ((data_store_checkout_url) && (data_store_checkout_url.length > 0) && (data_store_checkout_url.indexOf('/account/') == -1)) { 
                //Overwrite from Session
                checkoutUrl = data_store_checkout_url;
                //alert('read checkoutUrl 2 (session) = '+checkoutUrl);    	
            }  
            else if ((thisUrl) && (thisUrl.length > 0) && (thisUrl.indexOf('/account/') == -1)) {
                //Default state
                checkoutUrl = thisUrl;
                //alert('read checkoutUrl 3 (url) = '+checkoutUrl);
            }
            $('.redirecturl').attr('value',checkoutUrl);

        }
        catch (loginsesserr) {
            console.log("ERROR: "+loginsesserr.message);
            //alert(loginsesserr.message);
        }
    }
  
  	cacheRedirectUrl();
  
	/*
	* send reset password request to account/recover
    	response contains "No account found with that email" if no account.    
	*/
	$('.cd-user-modalllll').on("click",'.reset-password',function(event) {
      //alert('click reset-password');
		event.preventDefault();
		console.log('login-button clicked');
      	var theForm = $(this).parents('form');
      	if(theForm.valid()){
          var thisObj = $(this);
          theForm = thisObj.parents('form');
          var email = theForm.find('input[name="email"]').val();
          theForm.find('.error-message').removeClass('is-visible').html('');
          theForm.find('.success-message').removeClass('is-visible').html('');
          resetPassword(email).done(function (html) {
            console.log("resetPassword: "+html);
              //console.log('login ajax done');
              if (html.indexOf('No account found') !== -1) {
                  // no user with that email - show a message to the user
                  theForm.find('.error-message').addClass('is-visible');
                  //alert('No account found with that email');
              } else if ( html.indexOf('Too many attempts') !== -1) {
                	theForm.find('.error-message').html('Too many attempts: Please try again in 10 minutes' ).addClass('is-visible');
              } else {
                  // All good! Let's redirect if required
                  //console.log('Logged In');
                
                  var msgtouser = "We've sent you an email with a link to update your password. Please check your email and spam folder. \
                  <br />If you have any problems please contact us on <a href='"+window.livechatlink+"' target='_blank' >Chat</a> and we can assist you.";
                  
                  theForm.find('.success-message').html(msgtouser).addClass('is-visible');
                  var checkoutUrl = getCheckoutUrl();
                  if (checkoutUrl.length > 0) {
                      window.location.href = checkoutUrl;
                  } else {	
                      //window.location.reload(true);
                  }
              }
          }).fail(function (jqXHR, textStatus,errorThrown ) {

            	var msgtouser = "Sorry, an error has occurred, please try again - "+errorThrown+" \
             	<br />If you continue to experience problems please contact us on <a href='"+window.livechatlink+"' target='_blank' >Chat</a> and we can assist you.";            
            
            if ( errorThrown == 'Too Many Requests'){

              	msgtouser = "Too many attempts: Please try again in 10 minutes \
             	<br />If you continue to experience problems please contact us on <a href='"+window.livechatlink+"' target='_blank' >Chat</a> and we can assist you.";            
            
            }
            else{
            	             
            }
			theForm.find('.error-message').html(msgtouser).addClass('is-visible');
		  });
        }
	});
  
  
  
   		$('body').on('click', '.video-tab', function(event) {
          	$('.video-tab').removeClass('video-tab-active');
          	$(this).addClass('video-tab-active');
          	$('.video-panel').hide();
            if($(this).attr('id') == 'video-tab-pencil'){
				$('#video-panel-pencil').show();
            }
          	else if($(this).attr('id') ==  'video-tab-eyelet'){
				$('#video-panel-eyelet').show();
            }
          	else if($(this).attr('id') ==  'video-tab-pinch'){
				$('#video-panel-pinch').show();
            }
        }); 
  
  
  
	/*
	* Or if you're registering a user:
	*/
	$('body').on("click",'.register-button--',function(event) {
      	event.preventDefault();
      	console.log('register-button click');
      	var theForm = $(this).parents('form');
      	if(theForm.valid()){
          var email, password, firstName, lastName;
          register(email, password, firstName, lastName).done(function (html) {
			
            // logic for registration errors
            if (html.indexOf('email is invalid') !== -1) {

            } else if (html.indexOf('email can&#39;t be blank') !== -1) { 

            } else if (html.indexOf('password can&#39;t be blank.') !== -1) {

            }

          });
        }
	});
	/*
	* Log the customer in with their email and password.
	*/
	function login(email, password) { 
		try {
			var data = {
				'customer[email]': email,
				'customer[password]': password,
				form_type: 'customer_login',
				utf8: '?'
			};
		
			console.log("Login: "+window.this_domain+'/account/login');
			var promise = $.ajax({
				url: window.this_domain+'/account/login',
				method: 'post',
				data: data,
				dataType: 'html',
				async: true
			});
			return promise;
		}
		catch (loginERR) {
			console.log(loginERR.message);
		}
	}
  
  
	/*
	* Log the customer in with their email and password.
	*/
	function resetPassword(email) { 
		try {
			var data = {
				'email': email,
				form_type: 'recover-email',
				utf8: '?'
			};
		
			console.log("reset: "+window.this_domain+'/account/recover');
			var promise = $.ajax({
				url: window.this_domain+'/account/recover',
				method: 'post',
				data: data,
				dataType: 'html',
				async: true
			});
			return promise;
		}
		catch (loginERR) {
			console.log(loginERR.message);
		}
	}
	
	/*
	* Log the customer in with their email and password.
	*/
	function register(email, password, firstName, lastName) { 
		try {
			var data = {
			'customer[email]': email,
			'customer[password]': password,
			'customer[first_name]': firstName,
			'customer[last_name]': lastName,
			form_type: 'create_customer',
			utf8: '?'
			};
			
			console.log("data: "+data);
			var promise = $.ajax({
              url: window.this_domain+'/account',
              method: 'post',
              data: data,
              dataType: 'html',
              async: true
			});
			return promise;
		}
		catch (registerERR) {
			console.log('registerERR = '+registerERR.message);
		}
	}
	
	/*
	* Get the `checkout_url` from the URL query parameter, if it exists.
	* (It only ever exists on the /account/login page)
	*/
	function getCheckoutUrl() {  
		try {
			function getParameterByName(name) {
				name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
				var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
				results = regex.exec(location.search);
				return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
			}
			var churl = getParameterByName('checkout_url');
			console.log("Checkout: "+churl);
			return churl;
		}
		catch (loginERR) {
			console.log(loginERR.message);
		}
	}
  	/* -------------------------------------------------------- */
	/* ---------------------- AJAX LOGIN END ------------------ */
	/* -------------------------------------------------------- */
  
  
	/* -------------------------------------------------------- */
	/* ---------------------- login form ---------------------- */
	/* -------------------------------------------------------- */
  
  
  
  
        $('.cd-form').each(function(key, form) {
        	$(form).validate({
            	onkeyup: false
        	});
      	});
  
  		try {
  		$( ".password-field" ).rules( "add", {
        	required: true,
            minlength: 6,
            mypassword: true
		});
        } catch (err_passwordfield_rules) {}

  
  		try {
  		$.validator.addMethod('mypassword', function(value, element) {
        	/*return this.optional(element) || (value.match(/[a-zA-Z]/) && value.match(/[0-9]/));*/
          return this.optional(element) || (value.match(/^[a-zA-Z0-9]{6,}$/));
    	},
    	'Password must contain six or more alphanumeric characters.');
        } catch (err_validator_addMethod) {}
        //'Password must contain at least one numeric and one alphabetic character.');
  

		//open modal
		/**
		mainNav.on('click', function(event){
			$(event.target).is(mainNav) && mainNav.children('ul').toggleClass('is-visible');
		});
		**/
		//open sign-up form
		$('body').on("click",'.cd-signup',function(event) {
			event.preventDefault();
			signup_selected($('#cdswitcher'));
		});
		//open login-form form
		$('body').on("click",'.cd-signin',function(event) {
			event.preventDefault();
          	console.log($(this));
			login_selected($('#cdswitcher'));
		});
		//close modal !! but only cd-user-modal not static-cd-user-modal
      	$('body').on('click', '.cd-user-modal', function(event) {
          	var this_formModal = $(this);
			if( $(event.target).is(this_formModal) || $(event.target).is('.cd-close-form') ) {
				this_formModal.removeClass('is-visible');
			}	
		});
		//close modal when clicking the esc keyboard button
		$(document).keyup(function(event){
	    	if(event.which=='27'){
          try {
	    		formModal.removeClass('is-visible');
          } catch (errfm1) { }
		    }
	    });

		//switch from a tab to another
  		$('body').on('click', '.cd-switcher', function(event) {
          	var thisObj = $(this);
          	var formModal = thisObj.parents('.usermodal'),
			formLogin = formModal.find('#cd-login'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = $(this),
			tabLogin = thisObj.children('li').eq(0).children('a'),
			tabSignup = thisObj.children('li').eq(1).children('a'),
			mainNav = $('.main-nav'); 
          
			event.preventDefault();
			( $(event.target).is( tabLogin ) ) ? login_selected(thisObj) : signup_selected(thisObj);
		});

		//hide or show password
 		$('body').on('click', '.hide-password', function(event) {
			var togglePass = $(this),
			passwordField = togglePass.prev('input');
          
          	var formModal = togglePass.parents('.usermodal'),
            cdswitcher = formModal.find('.cd-switcher'),
            resetPassword = formModal.find('#cd-reset-password-submit'),
			formLogin = formModal.find('#cd-login'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = formModal.find('.cd-switcher'),
			tabLogin = formModalTab.children('li').eq(0).children('a'),
			tabSignup = formModalTab.children('li').eq(1).children('a'),
			mainNav = $('.main-nav'); 
          
			
			( 'password' == passwordField.attr('type') ) ? passwordField.attr('type', 'text') : passwordField.attr('type', 'password');
			( 'Hide' == togglePass.text() ) ? togglePass.text('Show') : togglePass.text('Hide');
			//focus and move cursor to the end of input field
			passwordField.putCursorAtEnd();
		});

		//show forgot-password form 
  		$('body').on('click', '.cd-form-forgot-pw', function(event) {
			event.preventDefault();
			forgot_password_selected($(this));
		});

		//back to login from the forgot-password form
  		$('body').on('click', '.cd-form-back-to-login', function(event) {
			event.preventDefault();
			login_selected($(this));
		});

		function login_selected(thisObj){
			/**mainNav.children('ul').removeClass('is-visible');**/
          	var formModal = thisObj.parents('.usermodal');
            var cdswitcher = formModal.find('.cd-switcher');
            var resetPassword = formModal.find('#cd-reset-password-submit');
			var formLogin = formModal.find('#cd-login');
			var formSignup = formModal.find('#cd-signup');
			var formForgotPassword = formModal.find('#cd-reset-password');
			var formModalTab = formModal.find('.cd-switcher');
			var tabLogin = formModalTab.children('li').eq(0).children('a');
			var tabSignup = formModalTab.children('li').eq(1).children('a');      
          
			console.log('----login_selected---------');
			formModal.addClass('is-visible');
          
			formLogin.addClass('is-selected');
          	cdswitcher.addClass('is-selected');
          	resetPassword.removeClass('is-selected');
			formSignup.removeClass('is-selected');
			formForgotPassword.removeClass('is-selected');
			tabLogin.addClass('selected');
			tabSignup.removeClass('selected');
		}

		function signup_selected(thisObj){
          	var formModal = thisObj.parents('.usermodal'),
			formLogin = formModal.find('#cd-login'),
            cdswitcher = formModal.find('.cd-switcher'),
            resetPassword = formModal.find('#cd-reset-password-submit'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = formModal.find('.cd-switcher'),
			tabLogin = formModalTab.children('li').eq(0).children('a'),
			tabSignup = formModalTab.children('li').eq(1).children('a'),
                
			mainNav = $('.main-nav'); 
          
			/**mainNav.children('ul').removeClass('is-visible');**/
			console.log('signup_selected');
          	cdswitcher.addClass('is-selected');
			formModal.addClass('is-visible');
          	resetPassword.removeClass('is-selected');
			formLogin.removeClass('is-selected');
			formSignup.addClass('is-selected');
			formForgotPassword.removeClass('is-selected');
			tabLogin.removeClass('selected');
			tabSignup.addClass('selected');
		}

		function forgot_password_selected(thisObj){
          	console.log('--------- forgot pw -----');
          	var formModal = thisObj.parents('.usermodal'),
			formLogin = formModal.find('#cd-login'),
            cdswitcher = formModal.find('.cd-switcher'),
            resetPassword = formModal.find('#cd-reset-password-submit'),
			formSignup = formModal.find('#cd-signup'),
			formForgotPassword = formModal.find('#cd-reset-password'),
			formModalTab = formModal.find('.cd-switcher'),
			tabLogin = formModalTab.children('li').eq(0).children('a'),
			tabSignup = formModalTab.children('li').eq(1).children('a'),
                
			mainNav = $('.main-nav'); 
          
			formLogin.removeClass('is-selected');
          	cdswitcher.addClass('is-selected');
          	resetPassword.removeClass('is-selected');
			formSignup.removeClass('is-selected');
			formForgotPassword.addClass('is-selected');
		}

		//REMOVE THIS - it's just to show error messages 
  		/**
		formLogin.find('input[type="submit"]').on('click', function(event){
			event.preventDefault();
			formLogin.find('input[type="email"]').toggleClass('has-error').next('span').toggleClass('is-visible');
		});
		formSignup.find('input[type="submit"]').on('click', function(event){
			event.preventDefault();
			formSignup.find('input[type="email"]').toggleClass('has-error').next('span').toggleClass('is-visible');
		});
        **/


		//IE9 placeholder fallback
		//credits http://www.hagenburger.net/BLOG/HTML5-Input-Placeholder-Fix-With-jQuery.html
		/**
		if(!Modernizr.input.placeholder){
			$('[placeholder]').focus(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
			  	}
			}).blur(function() {
			 	var input = $(this);
			  	if (input.val() == '' || input.val() == input.attr('placeholder')) {
					input.val(input.attr('placeholder'));
			  	}
			}).blur();
			$('[placeholder]').parents('form').submit(function() {
			  	$(this).find('[placeholder]').each(function() {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) {
				 		input.val('');
					}
			  	})
			});
		}
		**/
  

        $('body').on('change', '#customer-heade-nav', function(event) {
            console.log('change type selector----------------');
            if ($(this).val() != '') {
                location.href = $(this).val();
            }
        }); 
  
  
		/* -------------------------------------------------------- */
		/* ---------------------- login form END ------------------ */
		/* -------------------------------------------------------- */

  
  
		/* -------------------------------------------------------- */
		/* ------------------------- MINI CART -------------------- */
		/* -------------------------------------------------------- */
  		$('body').on('click', '.items-mobile-note-btn', function(event) {   
			var thisObj = $(this);
          	var parentObj = $(this).parents('form');
          	parentObj.find('.cart-note').prependTo($('.mobile-note-location-wrap')).show();
          	$(this).hide();
    	});
  
   		//add fasttrack
  
  		$('body').on('click', '.add_fastTrack', function(event) {   
          	var quantity = 0;
          	var variant_id = $(this).attr('data-line');
          	var cartfunc = Shopify.changeItem;
          	console.log('quantity = ' + quantity + ' | variant_id = ' + variant_id);
            if($(this).is(":checked")) {
              quantity = 1;
              cartfunc = Shopify.addItem;
              variant_id = $(this).val();
            }
          
          	cartfunc(variant_id, quantity, function() {
				$('body').trigger('refreshDrawer');
			});
    	});
  
        //clode the lateral panel
  		$('body').on('click', '.cd-panel, .close-mini-cart', function(event) {
            //console.log('panel click');
            if( $(event.target).is('.cd-panel') || $(event.target).is('.cd-panel-close') ) {
                $('.cd-panel').removeClass('is-visible');
                $('html').removeClass('minicart-open');
              	miniCartAdjustments();
                event.preventDefault();
            }
        });
  		$('body').on('click', '.item-properties-toggle', function(event) {
          	var opentext = $(this).attr('data-opentext');
          	var closetext = $(this).attr('data-closetext');
          	var parentrow = $(this).parents('.item-properties-wrap');
          	var texttouse = opentext;
          	if (parentrow.hasClass('open-details')){
            	texttouse = opentext;
              	parentrow.removeClass('open-details');
            }
          	else{
            	texttouse = closetext;
              	parentrow.removeClass('open-details').addClass('open-details');
          	}
          	$(this).text(texttouse);
        });

  
		/* -------------------------------------------------------- */
		/* ------------------------- MINI CART END ---------------- */
		/* -------------------------------------------------------- */
 
});



$(document).ready(function(){
  
  
	try {
        var $allVideos = $("iframe[src^='https://www.youtube.com']"),
        // The element that is fluid width
        $fluidEl = $("body");
        // Figure out and save aspect ratio for each video
        $allVideos.each(function() {
          var aspect_ratio = (this.height / this.width) * 100;
          $(this).data('aspectRatio', aspect_ratio);
          $(this).wrap( "<div style='padding-top:"+aspect_ratio+"%' class='videoWrapper'></div>" );
        });
	}
	catch ($allVideos_err) {
      console.log('Error: ' + $allVideos_err);
	}
  
  
  
	//console.log('#### getting browser');
	var BrowserDetect = {
			init: function () {
				this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
				this.language = this.searchString(this.dataLanguage) || "An unknown language";
				this.version = this.searchVersion(navigator.userAgent)
					|| this.searchVersion(navigator.appVersion)
					|| "an unknown version";
				this.OS = this.searchString(this.dataOS) || "an unknown OS";
			},
			searchString: function (data) {
				for (var i=0;i<data.length;i++)	{
					var dataString = data[i].string;
					var dataProp = data[i].prop;
					this.versionSearchString = data[i].versionSearch || data[i].identity;
					if (dataString) {
						if (dataString.indexOf(data[i].subString) != -1)
							return data[i].identity;
					}
					else if (dataProp)
						return data[i].identity;
				}
			},
			searchVersion: function (dataString) {
				var index = dataString.indexOf(this.versionSearchString);
				if (index == -1) return;
				return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
			},
			dataBrowser: [
				{
					string: navigator.userAgent,
					subString: "Chrome",
					identity: "chrome"
				},
				{ 	string: navigator.userAgent,
					subString: "OmniWeb",
					versionSearch: "OmniWeb/",
					identity: "OmniWeb"
				},
				{
					string: navigator.vendor,
					subString: "Apple",
					identity: "Safari",
					versionSearch: "Version"
				},
				{
					prop: window.opera,
					identity: "Opera",
					versionSearch: "Version"
				},
				{
					string: navigator.vendor,
					subString: "iCab",
					identity: "iCab"
				},
				{
					string: navigator.vendor,
					subString: "KDE",
					identity: "Konqueror"
				},
				{
					string: navigator.userAgent,
					subString: "Firefox",
					identity: "firefox"
				},
				{
					string: navigator.vendor,
					subString: "Camino",
					identity: "Camino"
				},
				{		// for newer Netscapes (6+)
					string: navigator.userAgent,
					subString: "Netscape",
					identity: "Netscape"
				},
				{
					string: navigator.userAgent,
					subString: "MSIE",
					identity: "explorer",
					versionSearch: "MSIE"
				},
				{
					string: navigator.userAgent,
					subString: "Gecko",
					identity: "Mozilla",
					versionSearch: "rv"
				},
				{
					string: navigator.userAgent,
					subString: "trident",
					identity: "explorer",
				},
				{ 		// for older Netscapes (4-)
					string: navigator.userAgent,
					subString: "Mozilla 2",
					identity: "Netscape",
					versionSearch: "Mozilla"
				}
			],
			dataLanguage: [
				{
					string: (navigator.language) ? navigator.language : navigator.userLanguage,
					subString: "US",
					identity: "us"
				},
				{
					string: (navigator.language) ? navigator.language : navigator.userLanguage,
					subString: "GB",
					identity: "uk"
				},
				{
					string: (navigator.language) ? navigator.language : navigator.userLanguage,
					subString: "DE",
					identity: "de"
				},
				{
					string: (navigator.language) ? navigator.language : navigator.userLanguage,
					subString: "IT",
					identity: "it"
				},
				{
					string: (navigator.language) ? navigator.language : navigator.userLanguage,
					subString: "FR",
					identity: "fr"
				},
			],
			dataOS : [
				{
					string: navigator.platform,
					subString: "Win",
					identity: "Windows"
				},
				{
					string: navigator.platform,
					subString: "Mac",
					identity: "Mac"
				},
				{
					   string: navigator.userAgent,
					   subString: "iPhone",
					   identity: "iPhone/iPod"
			    },
				{
					string: navigator.platform,
					subString: "Linux",
					identity: "Linux"
				}
			]
		};
		BrowserDetect.init();
		console.log('browser is ' + BrowserDetect.browser);
	    switch( BrowserDetect.browser.toLowerCase() )
	    {
	    case "safari":
	    	if($('body').hasClass('firefox-user')){
	    		$('body').removeClass('firefox-user').addClass('safari-user');
	    	} else {
	    		$('body').addClass('safari-user');
	    	}
	    break;
	
	    case "chrome":
	    	console.log('#### its chrome');
	    	$('body').removeClass('disableprodpop');
	    	if($('body').hasClass('firefox-user')){
	    		$('body').removeClass('firefox-user').addClass('chrome-user');
	    	} else {
	    		$('body').addClass('chrome-user');
	    	}
	      // $('a.btn_l').attr('href', 'https://chrome.google.com/webstore/detail/ok-prezzi/ockodmpodlgjmldenleapgeecpeiljen');
	      break;
	    case "firefox":
        case "mozilla":
	    	$('body').removeClass('disableprodpop');
	    	if($('body').hasClass('firefox-user')){
	    		$('body').removeClass('firefox-user').addClass('firefox-user');
	    	} else {
	    		$('body').addClass('firefox-user');
	    	}
	      break;	
	    case "explorer":
	    	$('body').removeClass('disableprodpop');
	    	if($('body').hasClass('iexplorer-user')){
	    		$('body').removeClass('iexplorer-user').addClass('iexplorer-user');
	    	} else {
	    		$('body').addClass('iexplorer-user');
	    	}
	      break;
	
	    default:
	    	//$('#boolyBody').removeClass().addClass('unknown-user');
	      break;
	    }
  		window.browserused = BrowserDetect.browser.toLowerCase();
});
